import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
// import { IoMdHelp } from "react-icons/io";
import { RiUserSearchLine } from "react-icons/ri";

//this is a comment section

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";

import Terms from "./components/Terms";
import Privacy from "./components/Privacy";

import {
  FaMoneyBillWave,
  FaGlobeAmericas,
  FaPassport,
  FaHome,
  FaExpand,
  FaChevronUp,
  FaChevronDown,
  FaRegQuestionCircle,
  FaSearch,
  FaQuoteLeft,
  FaTelegram,
  FaWhatsapp,
  FaImage,
  FaVideo,
  FaRegLightbulb,
  FaTimes,
  FaRegSmile,
  FaCheck,
  FaUserShield,
  FaCamera,
  FaChevronRight,
  FaChevronLeft,
  FaRegHandshake,
  FaPlane,
  FaThumbsUp,
} from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Modal from "react-modal";
import AnalyticsTracker from "./components/AnalyticsTracker";
import UserStats from "./components/UserStats";

Modal.setAppElement("#root"); // Set the root element for accessibility

// Enhanced dummy images with city-specific hero images
const dummyImages = {
  dubai: "/images/pic-3.png",
  istanbul: "/images/model-1.png",
  moscow:
    "https://plus.unsplash.com/premium_photo-1745626565687-9444deb02f75?q=80&w=3038&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  miami: "/images/model-3.png",
  beijing: "/images/model-2.png",
  ethiopianModel1: "/images/model-49.webp",
  ethiopianModel2: "/images/model-54.webp",
  ethiopianModel3: "/images/golden-model.png",
  performanceVideo:
    "https://images.unsplash.com/photo-1547153760-18fc86324498?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
  visaApproved:
    "https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
  partnerOne:
    "https://images.unsplash.com/photo-1630644964646-6cc8ac5b47ea?q=80&w=2742&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  partnerTwo:
    "https://images.unsplash.com/photo-1734714555326-d42a7a9f9728?q=80&w=3026&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  partnerThree:
    "https://images.unsplash.com/photo-1537402006040-bb6fb35ef422?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  partnerFour:
    "https://images.unsplash.com/photo-1520865649274-dfc80824ab25?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  partnerFive:
    "https://images.unsplash.com/photo-1613191662892-ff0f975fe033?q=80&w=2882&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  partnerSix:
    "https://images.unsplash.com/photo-1739288717744-308e1ebbbb28?q=80&w=3132&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  moscowCity:
    "https://plus.unsplash.com/premium_photo-1697730261041-ce58fb9acf29?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  istanbulCity:
    "https://images.unsplash.com/photo-1660128940648-73746c74974a?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  dubaiCity:
    "https://images.unsplash.com/photo-1599938030813-7637d7953c62?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  miamiCity:
    "https://plus.unsplash.com/premium_photo-1700566982166-b68382168778?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  beijingCity:
    "https://plus.unsplash.com/premium_photo-1664304488525-44a96338c0cc?q=80&w=2950&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
};

// Telegram Bot Integration - Enhanced with error handling
const sendToTelegram = async (formData, photos) => {
  const botToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
  const chatId = process.env.REACT_APP_TELEGRAM_CHAT_ID;

  if (!botToken || !chatId) {
    console.error("Telegram credentials missing");
    return false;
  }

  // Enhanced message formatting with emojis and structure
  const message = `
🌟 *New Talent Application Received* 🌟

👤 *Candidate Information*
├── ‍💼 *Name*: ${formData.name || "Not provided"}
├── 📱 *Phone*: ${formData.phone || "Not provided"}
├── 📸 *Instagram*: @${formData.instagram || "Not provided"}
└── 🌍 *Preferred City*: ${
    formData.cityPreference?.toUpperCase() || "Not specified"
  }

📝 *Experience Summary*:
${
  formData.experience
    ? formData.experience.substring(0, 300) + "..."
    : "Not provided"
}

🕒 *Submitted*: ${new Date().toLocaleString()}
`;

  try {
    // First send the text message
    const textResponse = await fetch(
      `https://api.telegram.org/bot${botToken}/sendMessage`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          text: message,
          parse_mode: "Markdown",
        }),
      }
    );

    if (!textResponse.ok) throw new Error("Text message failed");

    // Then send all photos if available
    for (const [type, file] of Object.entries(photos)) {
      if (file) {
        const photoFormData = new FormData();
        photoFormData.append("chat_id", chatId);
        photoFormData.append("photo", file);
        photoFormData.append(
          "caption",
          `📸 ${type.replace(/([A-Z])/g, " $1").trim()}`
        );

        await fetch(`https://api.telegram.org/bot${botToken}/sendPhoto`, {
          method: "POST",
          body: photoFormData,
        });
      }
    }

    return true;
  } catch (error) {
    console.error("Telegram notification failed:", error);
    return false;
  }
};

// Scroll to hash component for smooth navigation
function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);

  return null;
}

export default function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <ScrollToHash />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <HabeshaPortraitSlider />
              <BenefitsSections />
              <Testimonials />
              <ProcessTimeline />
              <ApplyForm />
              <Partners />
              <FAQ />
              <UserStats />
              <Footer />
            </>
          }
        />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}

// 1. Enhanced Hero Component with City-Specific Images
// function Hero() {
//   const cities = [
//     { name: "DUBAI", key: "dubai", tagline: "Where Dreams Become Reality" },
//     { name: "ISTANBUL", key: "istanbul", tagline: "East Meets West" },
//     { name: "MOSCOW", key: "moscow", tagline: "The Ultimate Stage" },
//     { name: "MIAMI", key: "miami", tagline: "American Dream Awaits" },
//     { name: "BEIJING", key: "beijing", tagline: "Ancient Meets Modern" },
//   ];

//   const [currentCity, setCurrentCity] = useState(0);
//   const [scrollIndicatorVisible, setScrollIndicatorVisible] = useState(true);
//   const [imageLoaded, setImageLoaded] = useState(false);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentCity((prev) => (prev + 1) % cities.length);
//       setImageLoaded(false); // Reset loaded state when city changes
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [cities.length]);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 100) {
//         setScrollIndicatorVisible(false);
//       } else {
//         setScrollIndicatorVisible(true);
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleImageLoad = () => {
//     setImageLoaded(true);
//   };

//   return (
//     <section className="relative h-screen bg-gradient-to-b from-gray-900 to-gray-800 overflow-hidden">
//       {/* Background image with dark overlay */}
//       <div className="absolute inset-0 z-0">
//         <div className="absolute inset-0 bg-black/60 z-10" />
//         <AnimatePresence mode="wait">
//           <motion.img
//             key={cities[currentCity].key}
//             src={dummyImages[cities[currentCity].key]}
//             alt={`${cities[currentCity].name} nightlife`}
//             className="w-full h-full object-cover"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: imageLoaded ? 1 : 0 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.8 }}
//             onLoad={handleImageLoad}
//             loading="eager"
//           />
//         </AnimatePresence>
//       </div>

//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//         className="relative z-10 h-full flex flex-col justify-center items-center text-center text-white px-4"
//       >
//         <div className="mb-4 md:mb-8">
//           <motion.div
//             className="inline-block bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 py-1 md:px-6 md:py-2 rounded-full md:mt-14 mb-4 md:mb-6 shadow-lg"
//             initial={{ scale: 0.9 }}
//             animate={{ scale: 1 }}
//             transition={{
//               repeat: Infinity,
//               repeatType: "reverse",
//               duration: 1.5,
//             }}
//           >
//             <span className="flex items-center font-semibold tracking-wide text-sm md:text-base ">
//               <FaGlobeAmericas className="mr-2" /> LUCY TALENT SCOUT
//             </span>
//           </motion.div>

//           <h1 className="text-3xl md:text-3xl font-bold mb-4 md:mb-6 leading-tight">
//             <span className="text-yellow-400">
//               Say Yes—The World Awaits You
//             </span>
//             <br />
//             <motion.span
//               key={cities[currentCity].name}
//               initial={{ opacity: 0, y: 10 }}
//               animate={{ opacity: 1, y: 0 }}
//               exit={{ opacity: 0, y: -10 }}
//               transition={{ duration: 0.7 }}
//               className="block mt-2 md:mt-4 text-2xl md:text-3xl"
//             >
//               Your Gateway to {cities[currentCity].name} Nightlife
//             </motion.span>
//           </h1>
//           <motion.p
//             key={`tagline-${cities[currentCity].key}`}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="text-lg md:text-xl text-yellow-200 italic"
//           >
//             {cities[currentCity].tagline}
//           </motion.p>
//         </div>

//         <ScarcityBadge />
//         <CountdownTimer />

//         {/* Ross Jeffries Principle: Embedded Commands with Sensory Language */}
//         <motion.div
//           className="mb-8 md:mb-14 max-w-2xl mx-auto bg-black/40 p-4 md:p-8 rounded-xl border border-yellow-400/30 backdrop-blur-sm"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ delay: 0.5 }}
//         >
//           <p className="mb-3 md:mb-4 italic text-base md:text-lg">
//             "When you imagine yourself performing in {cities[currentCity].name},
//             you can{" "}
//             <span className="font-bold text-yellow-300">
//               feel the excitement
//             </span>{" "}
//             building inside you..."
//           </p>
//           <p className="mb-4 md:mb-6 italic text-base md:text-lg">
//             "The selected few experience{" "}
//             <span className="font-bold text-yellow-300">
//               Visa Sponsorship • $4K+ Monthly • Luxury Accommodation
//             </span>
//             "
//           </p>
//           <motion.a
//             href="#apply"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="inline-block bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-3 px-8 md:py-4 md:px-10 rounded-full text-base md:text-lg transition-all shadow-lg hover:shadow-xl"
//           >
//             Begin Your Journey Now
//           </motion.a>
//         </motion.div>

//         {/* Scroll indicator with animation */}
//         {scrollIndicatorVisible && (
//           <motion.div
//             className="absolute bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2"
//             animate={{ y: [0, 10, 0] }}
//             transition={{ repeat: Infinity, duration: 2 }}
//           >
//             <div className="flex flex-col items-center">
//               <p className="text-xs md:text-sm mb-1 md:mb-2 text-white/80">
//                 Discover More
//               </p>
//               <div className="w-5 h-8 md:w-6 md:h-10 border-2 border-yellow-400 rounded-full flex justify-center">
//                 <motion.div
//                   className="w-1 h-2 bg-yellow-400 rounded-full mt-1 md:mt-2"
//                   animate={{ y: [0, 4, 0] }}
//                   transition={{ repeat: Infinity, duration: 1.5 }}
//                 />
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </motion.div>
//     </section>
//   );
// }
// const HabeshaPortraitSlider = () => {
//   // Dummy data matching our AI-generated prompts
//   const portraits = [
//     {
//       id: 1,
//       src: "/images/model(1).png",
//       title: "Golden Caramel Beauty",
//       description: "HEX #B76E54 with amber undertones",
//       prompt:
//         "Ultra-realistic portrait with symmetrical features and satin-matte complexion",
//     },
//     {
//       id: 2,
//       src: "/images/model(2).png",
//       title: "Honey-Brown Elegance",
//       description: "HEX #9C5D34 with olive undertones",
//       prompt:
//         "Studio portrait with butterfly lighting and professional retouching",
//     },
//     {
//       id: 3,
//       src: "/images/model(3).png",
//       title: "Toffee-Toned Grace",
//       description: "HEX #7F4A33 with russet undertones",
//       prompt: "Canon EOS R5, 85mm shot with Kodak Portra 400 simulation",
//     },
//     {
//       id: 4,
//       src: "/images/model(4).png",
//       title: "Mocha Warmth",
//       description: "HEX #6B3A24 with golden highlights",
//       prompt: "Neutral confident expression with slight head tilt",
//     },
//     {
//       id: 5,
//       src: "/images/model(5).png",
//       title: "Cinnamon Glow",
//       description: "HEX #D39C6A with natural freckles",
//       prompt: "Full lips, wide almond eyes with long lashes",
//     },
//     {
//       id: 6,
//       src: "/images/model(6).png",
//       title: "Amber Bronze",
//       description: "HEX #C67C4D with hooded eyes",
//       prompt: "Slicked-back bun hairstyle with minimal makeup",
//     },
//     {
//       id: 7,
//       src: "/images/model(7).png",
//       title: "Mahogany Rich",
//       description: "HEX #5E2C19 with red undertones",
//       prompt: "Professional studio lighting with dark gray backdrop",
//     },
//     {
//       id: 8,
//       src: "/images/model(8).png",
//       title: "Terra-Cotta Glow",
//       description: "HEX #A05C3C with warm undertones",
//       prompt: "High-cheekboned portrait with glossy nude lips",
//     },
//     {
//       id: 9,
//       src: "/images/model(9).png",
//       title: "Spiced Brown",
//       description: "HEX #8A4B2A with golden-red undertones",
//       prompt: "Downturned eyes with blunt bob hairstyle",
//     },
//     {
//       id: 10,
//       src: "/images/model(10).png",
//       title: "Golden-Red",
//       description: "HEX #B2673E with sun-kissed glow",
//       prompt: "Tigrayan features with golden leaf eyeliner",
//     },
//     {
//       id: 11,
//       src: "/images/model(11).png",
//       title: "Warm Almond",
//       description: "HEX #C88D5F with golden-olive undertones",
//       prompt: "Delicate nose with rosy lips and shimmering highlight",
//     },
//     {
//       id: 12,
//       src: "/images/model(12).png",
//       title: "Copper-Red",
//       description: "HEX #B56A3E with freckled nose",
//       prompt: "Deep-set eyes with extended winged liner",
//     },
//     {
//       id: 13,
//       src: "/images/model(13).png",
//       title: "Golden-Tan",
//       description: "HEX #E0A073 with oval face",
//       prompt: "Doe eyes with long lashes and half-up box braids",
//     },
//     {
//       id: 14,
//       src: "/images/model(14).png",
//       title: "Spiced Honey",
//       description: "HEX #A05C3C with russet tones",
//       prompt: "High cheekbones with blotted berry lips",
//     },
//     {
//       id: 15,
//       src: "/images/model(15).png",
//       title: "Caramel-Bronze",
//       description: "HEX #D18B55 with round face",
//       prompt: "Monolid eyes with gold shadow and voluminous afro",
//     },
//     {
//       id: 16,
//       src: "/images/model(16).png",
//       title: "Amber-Glow",
//       description: "HEX #C67C4D with sharp jawline",
//       prompt: "Headwrap with dangling amber beads",
//     },
//     {
//       id: 17,
//       src: "/images/model(17).png",
//       title: "Mocha-Rose",
//       description: "HEX #8A4B2A with heart-shaped face",
//       prompt: "Blush-heavy cheeks with micro braids",
//     },
//     {
//       id: 18,
//       src: "/images/model(18).png",
//       title: "Terra-Cotta",
//       description: "HEX #B2673E with wide nose",
//       prompt: "Stained berry lips with short curly frohawk",
//     },
//     {
//       id: 19,
//       src: "/images/model(19).png",
//       title: "Toffee-Cream",
//       description: "HEX #E3B089 with epicanthic folds",
//       prompt: "Feathered brows with long Senegalese twists",
//     },
//     {
//       id: 20,
//       src: "/images/model(20).png",
//       title: "Cinnamon-Dust",
//       description: "HEX #9C5D34 with downturned eyes",
//       prompt: "Thin gold chain headpiece with matte brown lips",
//     },
//     {
//       id: 21,
//       src: "/images/model(21).png",
//       title: "Golden-Russet",
//       description: "HEX #B76E54 with dimpled chin",
//       prompt: "Bantu knots with baby hairs laid",
//     },
//     {
//       id: 22,
//       src: "/images/model(22).png",
//       title: "Mahogany-Sheen",
//       description: "HEX #6B3A24 with broad forehead",
//       prompt: "Cat-eye liner with faux locs",
//     },
//     {
//       id: 23,
//       src: "/images/model(23).png",
//       title: "Honey-Olive",
//       description: "HEX #C88D5F with button nose",
//       prompt: "High puff hairstyle with gold stud earrings",
//     },
//     {
//       id: 24,
//       src: "/images/model(24).png",
//       title: "Amber-Wood",
//       description: "HEX #A05C3C with thick brows",
//       prompt: "Cornrows with cowrie shells",
//     },
//     {
//       id: 25,
//       src: "/images/model(25).png",
//       title: "Spiced Latte",
//       description: "HEX #D39C6A with freckles",
//       prompt: "Slicked-back bun with gold foil eyeliner",
//     },
//     {
//       id: 26,
//       src: "/images/model(26).png",
//       title: "Caramel-Sunset",
//       description: "HEX #E0A073 with monolid eyes",
//       prompt: "High ponytail with peach gloss",
//     },
//     {
//       id: 27,
//       src: "/images/model(27).png",
//       title: "Bronze-Clay",
//       description: "HEX #B56A3E with sharp contour",
//       prompt: "Twisted updo with hair pins",
//     },
//     {
//       id: 28,
//       src: "/images/model(28).png",
//       title: "Mocha-Spice",
//       description: "HEX #8A4B2A with rounded cheeks",
//       prompt: "Braided crown with minimal makeup",
//     },
//     {
//       id: 29,
//       src: "/images/model(29).png",
//       title: "Golden-Sand",
//       description: "HEX #D18B55 with almond eyes",
//       prompt: "Short afro with side part",
//     },
//     {
//       id: 30,
//       src: "/images/model(30).png",
//       title: "Terra-Gold",
//       description: "HEX #B2673E with wide smile",
//       prompt: "Box braids with gold threads",
//     },
//     {
//       id: 31,
//       src: "/images/model(31).png",
//       title: "Cinnamon-Matte",
//       description: "HEX #9C5D34 with high cheekbones",
//       prompt: "Sleek low bun with diamond studs",
//     },
//     {
//       id: 32,
//       src: "/images/model(32).png",
//       title: "Amber-Silk",
//       description: "HEX #C67C4D with hooded eyes",
//       prompt: "Headwrap with curly fringe",
//     },
//     {
//       id: 33,
//       src: "/images/model(33).png",
//       title: "Mahogany-Satin",
//       description: "HEX #6B3A24 with full brows",
//       prompt: "Buzz cut with henna patterns",
//     },
//     {
//       id: 34,
//       src: "/images/model(34).png",
//       title: "Honey-Suede",
//       description: "HEX #C88D5F with soft features",
//       prompt: "Long braids with beads",
//     },
//     {
//       id: 35,
//       src: "/images/model(35).png",
//       title: "Spiced-Sun",
//       description: "HEX #D39C6A with freckled nose",
//       prompt: "Pixie cut with side shave",
//     },
//   ];

//   return (
//     <section className="py-12 md:py-16 bg-gradient-to-b from-gray-900 to-gray-800">
//       <div className="container mx-auto px-4">
//         <div className="text-center mb-8 md:mb-12">
//           <h2 className="text-2xl md:text-3xl font-bold mb-3 text-white">
//             <span className="text-yellow-400">Habesha Beauty</span> Showcase
//           </h2>
//           <p className="text-gray-300 max-w-2xl mx-auto text-sm md:text-base">
//             Ultra-realistic studio portraits featuring diverse Ethiopian beauty
//           </p>
//         </div>

//         <div className="relative">
//           <Swiper
//             modules={[Autoplay, Navigation]}
//             spaceBetween={20}
//             slidesPerView={1}
//             breakpoints={{
//               640: {
//                 slidesPerView: 2,
//               },
//               1024: {
//                 slidesPerView: 3,
//               },
//             }}
//             autoplay={{
//               delay: 5000,
//               disableOnInteraction: false,
//             }}
//             navigation={{
//               prevEl: ".swiper-button-prev",
//               nextEl: ".swiper-button-next",
//             }}
//             className="pb-12"
//           >
//             {portraits.map((portrait) => (
//               <SwiperSlide key={portrait.id}>
//                 <motion.div
//                   className="bg-white rounded-xl overflow-hidden shadow-xl h-full"
//                   whileHover={{ y: -10 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <div className="relative h-64 md:h-80 w-full">
//                     <LazyLoadImage
//                       src={portrait.src}
//                       alt={portrait.title}
//                       className="w-full h-full object-cover"
//                       effect="blur"
//                       width="100%"
//                       height="100%"
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent flex items-end p-4">
//                       <div>
//                         <h3 className="text-white font-bold text-lg md:text-xl">
//                           {portrait.title}
//                         </h3>
//                         <p className="text-yellow-200 text-sm">
//                           {portrait.description}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="p-4 md:p-6 bg-gray-50">
//                     <p className="text-gray-600 text-xs md:text-sm italic">
//                       "{portrait.prompt}"
//                     </p>
//                     <div className="mt-3 flex justify-between items-center">
//                       <span className="text-xs text-gray-500">
//                         AI-Generated Portrait
//                       </span>
//                       <button className="text-yellow-600 hover:text-yellow-700 text-xs font-medium">
//                         View Prompt
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               </SwiperSlide>
//             ))}
//           </Swiper>

//           {/* Custom Navigation */}
//           <button className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full ml-2">
//             <FaChevronLeft />
//           </button>
//           <button className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full mr-2">
//             <FaChevronRight />
//           </button>
//         </div>

//         <div className="text-center mt-6">
//           <p className="text-gray-400 text-sm max-w-2xl mx-auto">
//             Each portrait is generated using our specialized AI prompts to
//             highlight the diverse beauty of Ethiopian women across different
//             skin tones.
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };
//
// const HabeshaPortraitSlider = () => {
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [selectedPortrait, setSelectedPortrait] = useState(null);

//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   const portraits = [
//     {
//       id: 1,
//       src: "/images/model-one.png",
//       title: "Golden Caramel Beauty",
//       description: "HEX #B76E54 with amber undertones",
//       prompt:
//         "Ultra-realistic portrait with symmetrical features and satin-matte complexion",
//     },
//     {
//       id: 2,
//       src: "/images/model-two.png",
//       title: "Honey-Brown Elegance",
//       description: "HEX #9C5D34 with olive undertones",
//       prompt:
//         "Studio portrait with butterfly lighting and professional retouching",
//     },
//     {
//       id: 3,
//       src: "/images/model-three.png",
//       title: "Toffee-Toned Grace",
//       description: "HEX #7F4A33 with russet undertones",
//       prompt: "Canon EOS R5, 85mm shot with Kodak Portra 400 simulation",
//     },
//     {
//       id: 4,
//       src: "/images/model-four.png",
//       title: "Mocha Warmth",
//       description: "HEX #6B3A24 with golden highlights",
//       prompt: "Neutral confident expression with slight head tilt",
//     },
//     {
//       id: 5,
//       src: "/images/model-five.png",
//       title: "Cinnamon Glow",
//       description: "HEX #D39C6A with natural freckles",
//       prompt: "Full lips, wide almond eyes with long lashes",
//     },
//     {
//       id: 6,
//       src: "/images/model-six.png",
//       title: "Amber Bronze",
//       description: "HEX #C67C4D with hooded eyes",
//       prompt: "Slicked-back bun hairstyle with minimal makeup",
//     },
//     {
//       id: 7,
//       src: "/images/model-seven.png",
//       title: "Mahogany Rich",
//       description: "HEX #5E2C19 with red undertones",
//       prompt: "Professional studio lighting with dark gray backdrop",
//     },
//     {
//       id: 8,
//       src: "/images/model-eight.png",
//       title: "Terra-Cotta Glow",
//       description: "HEX #A05C3C with warm undertones",
//       prompt: "High-cheekboned portrait with glossy nude lips",
//     },
//     {
//       id: 9,
//       src: "/images/model-nine.png",
//       title: "Spiced Brown",
//       description: "HEX #8A4B2A with golden-red undertones",
//       prompt: "Downturned eyes with blunt bob hairstyle",
//     },
//     {
//       id: 10,
//       src: "/images/model-ten.png",
//       title: "Golden-Red",
//       description: "HEX #B2673E with sun-kissed glow",
//       prompt: "Tigrayan features with golden leaf eyeliner",
//     },
//     {
//       id: 11,
//       src: "/images/model-eleven.png",
//       title: "Warm Almond",
//       description: "HEX #C88D5F with golden-olive undertones",
//       prompt: "Delicate nose with rosy lips and shimmering highlight",
//     },
//     {
//       id: 12,
//       src: "/images/model-12.png",
//       title: "Copper-Red",
//       description: "HEX #B56A3E with freckled nose",
//       prompt: "Deep-set eyes with extended winged liner",
//     },
//     {
//       id: 13,
//       src: "/images/model-13.png",
//       title: "Golden-Tan",
//       description: "HEX #E0A073 with oval face",
//       prompt: "Doe eyes with long lashes and half-up box braids",
//     },
//     {
//       id: 14,
//       src: "/images/model-14.png",
//       title: "Spiced Honey",
//       description: "HEX #A05C3C with russet tones",
//       prompt: "High cheekbones with blotted berry lips",
//     },
//     {
//       id: 15,
//       src: "/images/model-15.png",
//       title: "Caramel-Bronze",
//       description: "HEX #D18B55 with round face",
//       prompt: "Monolid eyes with gold shadow and voluminous afro",
//     },
//     {
//       id: 16,
//       src: "/images/model-16.png",
//       title: "Amber-Glow",
//       description: "HEX #C67C4D with sharp jawline",
//       prompt: "Headwrap with dangling amber beads",
//     },
//     {
//       id: 17,
//       src: "/images/model-17.png",
//       title: "Mocha-Rose",
//       description: "HEX #8A4B2A with heart-shaped face",
//       prompt: "Blush-heavy cheeks with micro braids",
//     },
//     {
//       id: 18,
//       src: "/images/model-18.png",
//       title: "Terra-Cotta",
//       description: "HEX #B2673E with wide nose",
//       prompt: "Stained berry lips with short curly frohawk",
//     },
//     {
//       id: 19,
//       src: "/images/model-19.png",
//       title: "Toffee-Cream",
//       description: "HEX #E3B089 with epicanthic folds",
//       prompt: "Feathered brows with long Senegalese twists",
//     },
//     {
//       id: 20,
//       src: "/images/model-20.png",
//       title: "Cinnamon-Dust",
//       description: "HEX #9C5D34 with downturned eyes",
//       prompt: "Thin gold chain headpiece with matte brown lips",
//     },
//     {
//       id: 21,
//       src: "/images/model-21.png",
//       title: "Golden-Russet",
//       description: "HEX #B76E54 with dimpled chin",
//       prompt: "Bantu knots with baby hairs laid",
//     },
//     {
//       id: 22,
//       src: "/images/model-22.png",
//       title: "Mahogany-Sheen",
//       description: "HEX #6B3A24 with broad forehead",
//       prompt: "Cat-eye liner with faux locs",
//     },
//     {
//       id: 23,
//       src: "/images/model-23.png",
//       title: "Honey-Olive",
//       description: "HEX #C88D5F with button nose",
//       prompt: "High puff hairstyle with gold stud earrings",
//     },
//     {
//       id: 24,
//       src: "/images/model-24.png",
//       title: "Amber-Wood",
//       description: "HEX #A05C3C with thick brows",
//       prompt: "Cornrows with cowrie shells",
//     },
//     {
//       id: 25,
//       src: "/images/model-25.png",
//       title: "Spiced Latte",
//       description: "HEX #D39C6A with freckles",
//       prompt: "Slicked-back bun with gold foil eyeliner",
//     },
//     {
//       id: 26,
//       src: "/images/model-26.png",
//       title: "Caramel-Sunset",
//       description: "HEX #E0A073 with monolid eyes",
//       prompt: "High ponytail with peach gloss",
//     },
//     {
//       id: 27,
//       src: "/images/model-27.png",
//       title: "Bronze-Clay",
//       description: "HEX #B56A3E with sharp contour",
//       prompt: "Twisted updo with hair pins",
//     },
//     {
//       id: 28,
//       src: "/images/model-28.png",
//       title: "Mocha-Spice",
//       description: "HEX #8A4B2A with rounded cheeks",
//       prompt: "Braided crown with minimal makeup",
//     },
//     {
//       id: 29,
//       src: "/images/model-29.png",
//       title: "Golden-Sand",
//       description: "HEX #D18B55 with almond eyes",
//       prompt: "Short afro with side part",
//     },
//     {
//       id: 30,
//       src: "/images/model-30.png",
//       title: "Terra-Gold",
//       description: "HEX #B2673E with wide smile",
//       prompt: "Box braids with gold threads",
//     },
//     {
//       id: 31,
//       src: "/images/model-31.png",
//       title: "Cinnamon-Matte",
//       description: "HEX #9C5D34 with high cheekbones",
//       prompt: "Sleek low bun with diamond studs",
//     },
//     {
//       id: 32,
//       src: "/images/model-32.png",
//       title: "Amber-Silk",
//       description: "HEX #C67C4D with hooded eyes",
//       prompt: "Headwrap with curly fringe",
//     },
//     {
//       id: 33,
//       src: "/images/model-33.png",
//       title: "Mahogany-Satin",
//       description: "HEX #6B3A24 with full brows",
//       prompt: "Buzz cut with henna patterns",
//     },
//     {
//       id: 34,
//       src: "/images/model-34.png",
//       title: "Honey-Suede",
//       description: "HEX #C88D5F with soft features",
//       prompt: "Long braids with beads",
//     },
//     {
//       id: 35,
//       src: "/images/model-35.png",
//       title: "Spiced-Sun",
//       description: "HEX #D39C6A with freckled nose",
//       prompt: "Pixie cut with side shave",
//     },
//   ];

//   const openModal = (portrait) => {
//     setSelectedPortrait(portrait);
//     setModalIsOpen(true);
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };

//   return (
//     <section className="py-12 md:py-16 bg-gradient-to-b from-gray-900 to-gray-800">
//       <div className="container mx-auto px-4">
//         <div className="text-center mb-8 md:mb-12">
//           <h2 className="text-2xl md:text-3xl font-bold mb-3 text-white">
//             <span className="text-yellow-400">Habesha Beauty</span> Showcase
//           </h2>
//           <p className="text-gray-300 max-w-2xl mx-auto text-sm md:text-base">
//             Ultra-realistic studio portraits featuring diverse Ethiopian beauty
//           </p>
//         </div>

//         <div className="relative">
//           <Swiper
//             modules={[Autoplay, Navigation]}
//             spaceBetween={20}
//             slidesPerView={1}
//             breakpoints={{
//               640: {
//                 slidesPerView: 2,
//               },
//               1024: {
//                 slidesPerView: 3,
//               },
//             }}
//             autoplay={{
//               delay: 5000,
//               disableOnInteraction: false,
//             }}
//             navigation={{
//               prevEl: ".swiper-button-prev",
//               nextEl: ".swiper-button-next",
//             }}
//             className="pb-12"
//           >
//             {portraits.map((portrait) => (
//               <SwiperSlide key={portrait.id}>
//                 <motion.div
//                   className="bg-white rounded-xl overflow-hidden shadow-xl h-full"
//                   whileHover={{ y: -10 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <div className="relative h-64 md:h-80 w-full group">
//                     <LazyLoadImage
//                       src={portrait.src}
//                       alt={portrait.title}
//                       className="w-full h-full object-cover"
//                       effect="blur"
//                       width="100%"
//                       height="100%"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = "/images/placeholder.png";
//                       }}
//                     />
//                     <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent flex items-end p-4">
//                       <div>
//                         <h3 className="text-white font-bold text-lg md:text-xl">
//                           {portrait.title}
//                         </h3>
//                         <p className="text-yellow-200 text-sm">
//                           {portrait.description}
//                         </p>
//                       </div>
//                     </div>
//                     <button
//                       onClick={() => openModal(portrait)}
//                       className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
//                       aria-label="View portrait in full screen"
//                     >
//                       <FaExpand className="text-sm" />
//                     </button>
//                   </div>
//                   <div className="p-4 md:p-6 bg-gray-50">
//                     <p className="text-gray-600 text-xs md:text-sm italic">
//                       "{portrait.prompt}"
//                     </p>
//                     <div className="mt-3 flex justify-between items-center">
//                       <span className="text-xs text-gray-500">
//                         AI-Generated Portrait
//                       </span>
//                       <button
//                         onClick={() => openModal(portrait)}
//                         className="text-yellow-600 hover:text-yellow-700 text-xs font-medium flex items-center"
//                       >
//                         View Portrait
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               </SwiperSlide>
//             ))}
//           </Swiper>

//           {/* Custom Navigation */}
//           <button className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full ml-2">
//             <FaChevronLeft />
//           </button>
//           <button className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full mr-2">
//             <FaChevronRight />
//           </button>
//         </div>

//         <div className="text-center mt-6">
//           <p className="text-gray-400 text-sm max-w-2xl mx-auto">
//             Each portrait is generated using our specialized AI prompts to
//             highlight the diverse beauty of Ethiopian women across different
//             skin tones.
//           </p>
//         </div>

//         {/* Fullscreen Modal */}
//         <Modal
//           isOpen={modalIsOpen}
//           onRequestClose={closeModal}
//           contentLabel="Portrait View"
//           className="modal"
//           overlayClassName="modal-overlay"
//         >
//           {selectedPortrait && (
//             <div className="relative h-full w-full flex flex-col">
//               <div className="flex-grow flex items-center justify-center p-4">
//                 <img
//                   src={selectedPortrait.src}
//                   alt={selectedPortrait.title}
//                   className="max-h-full max-w-full object-contain"
//                   onError={(e) => {
//                     e.target.onerror = null;
//                     e.target.src = "/images/placeholder.png";
//                   }}
//                 />
//               </div>
//               <div className="bg-white p-4 md:p-6">
//                 <h3 className="font-bold text-lg md:text-xl">
//                   {selectedPortrait.title}
//                 </h3>
//                 <p className="text-yellow-600 text-sm md:text-base">
//                   {selectedPortrait.description}
//                 </p>
//                 <p className="text-gray-600 mt-2 text-sm md:text-base italic">
//                   "{selectedPortrait.prompt}"
//                 </p>
//               </div>
//               <button
//                 onClick={closeModal}
//                 className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full"
//                 aria-label="Close modal"
//               >
//                 <svg
//                   className="w-5 h-5"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>
//           )}
//         </Modal>
//       </div>

//       {/* Modal Styles */}
//       <style jsx global>{`
//         .modal {
//           position: fixed;
//           top: 50%;
//           left: 50%;
//           right: auto;
//           bottom: auto;
//           transform: translate(-50%, -50%);
//           background: transparent;
//           padding: 0;
//           border: none;
//           width: 90%;
//           max-width: 800px;
//           height: 90vh;
//           max-height: 800px;
//           outline: none;
//         }

//         .modal-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.9);
//           z-index: 1000;
//         }

//         @media (max-width: 768px) {
//           .modal {
//             width: 95%;
//             height: 80vh;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// Preload images function outside component
const preloadImages = (imageUrls) => {
  return Promise.all(
    imageUrls.map((url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = resolve;
        img.onerror = resolve; // Resolve even if fails to prevent blocking
      });
    })
  );
};

const HabeshaPortraitSlider = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedPortrait, setSelectedPortrait] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // Optimized portrait data with placeholder for initial display
  // const portraits = [
  //   {
  //     id: 1,
  //     src: "/images/model-one.png",
  //     title: "Golden Caramel Beauty",
  //     description: "HEX #B76E54 with amber undertones",
  //     prompt:
  //       "Ultra-realistic portrait with symmetrical features and satin-matte complexion",
  //   },
  //   {
  //     id: 2,
  //     src: "/images/model-50.webp",
  //     title: "Honey-Brown Elegance",
  //     description: "HEX #9C5D34 with olive undertones",
  //     prompt:
  //       "Studio portrait with butterfly lighting and professional retouching",
  //   },
  //   {
  //     id: 3,
  //     src: "/images/model-three.png",
  //     title: "Toffee-Toned Grace",
  //     description: "HEX #7F4A33 with russet undertones",
  //     prompt: "Canon EOS R5, 85mm shot with Kodak Portra 400 simulation",
  //   },
  //   {
  //     id: 4,
  //     src: "/images/model-four.png",
  //     title: "Mocha Warmth",
  //     description: "HEX #6B3A24 with golden highlights",
  //     prompt: "Neutral confident expression with slight head tilt",
  //   },
  //   {
  //     id: 5,
  //     src: "/images/model-five.png",
  //     title: "Cinnamon Glow",
  //     description: "HEX #D39C6A with natural freckles",
  //     prompt: "Full lips, wide almond eyes with long lashes",
  //   },
  //   {
  //     id: 6,
  //     src: "/images/model-six.png",
  //     title: "Amber Bronze",
  //     description: "HEX #C67C4D with hooded eyes",
  //     prompt: "Slicked-back bun hairstyle with minimal makeup",
  //   },
  //   {
  //     id: 7,
  //     src: "/images/model-seven.png",
  //     title: "Mahogany Rich",
  //     description: "HEX #5E2C19 with red undertones",
  //     prompt: "Professional studio lighting with dark gray backdrop",
  //   },
  //   {
  //     id: 8,
  //     src: "/images/model-eight.png",
  //     title: "Terra-Cotta Glow",
  //     description: "HEX #A05C3C with warm undertones",
  //     prompt: "High-cheekboned portrait with glossy nude lips",
  //   },
  //   {
  //     id: 9,
  //     src: "/images/model-nine.png",
  //     title: "Spiced Brown",
  //     description: "HEX #8A4B2A with golden-red undertones",
  //     prompt: "Downturned eyes with blunt bob hairstyle",
  //   },
  //   {
  //     id: 10,
  //     src: "/images/model-ten.png",
  //     title: "Golden-Red",
  //     description: "HEX #B2673E with sun-kissed glow",
  //     prompt: "Tigrayan features with golden leaf eyeliner",
  //   },
  //   {
  //     id: 11,
  //     src: "/images/model-eleven.png",
  //     title: "Warm Almond",
  //     description: "HEX #C88D5F with golden-olive undertones",
  //     prompt: "Delicate nose with rosy lips and shimmering highlight",
  //   },
  //   {
  //     id: 12,
  //     src: "/images/model-12.png",
  //     title: "Copper-Red",
  //     description: "HEX #B56A3E with freckled nose",
  //     prompt: "Deep-set eyes with extended winged liner",
  //   },
  //   {
  //     id: 13,
  //     src: "/images/model-13.png",
  //     title: "Golden-Tan",
  //     description: "HEX #E0A073 with oval face",
  //     prompt: "Doe eyes with long lashes and half-up box braids",
  //   },
  //   {
  //     id: 14,
  //     src: "/images/model-14.png",
  //     title: "Spiced Honey",
  //     description: "HEX #A05C3C with russet tones",
  //     prompt: "High cheekbones with blotted berry lips",
  //   },
  //   {
  //     id: 15,
  //     src: "/images/model-15.png",
  //     title: "Caramel-Bronze",
  //     description: "HEX #D18B55 with round face",
  //     prompt: "Monolid eyes with gold shadow and voluminous afro",
  //   },
  //   {
  //     id: 16,
  //     src: "/images/model-16.png",
  //     title: "Amber-Glow",
  //     description: "HEX #C67C4D with sharp jawline",
  //     prompt: "Headwrap with dangling amber beads",
  //   },
  //   {
  //     id: 17,
  //     src: "/images/model-17.png",
  //     title: "Mocha-Rose",
  //     description: "HEX #8A4B2A with heart-shaped face",
  //     prompt: "Blush-heavy cheeks with micro braids",
  //   },
  //   {
  //     id: 18,
  //     src: "/images/model-18.png",
  //     title: "Terra-Cotta",
  //     description: "HEX #B2673E with wide nose",
  //     prompt: "Stained berry lips with short curly frohawk",
  //   },
  //   {
  //     id: 19,
  //     src: "/images/model-19.png",
  //     title: "Toffee-Cream",
  //     description: "HEX #E3B089 with epicanthic folds",
  //     prompt: "Feathered brows with long Senegalese twists",
  //   },
  //   {
  //     id: 20,
  //     src: "/images/model-20.png",
  //     title: "Cinnamon-Dust",
  //     description: "HEX #9C5D34 with downturned eyes",
  //     prompt: "Thin gold chain headpiece with matte brown lips",
  //   },
  //   {
  //     id: 21,
  //     src: "/images/model-21.png",
  //     title: "Golden-Russet",
  //     description: "HEX #B76E54 with dimpled chin",
  //     prompt: "Bantu knots with baby hairs laid",
  //   },
  //   {
  //     id: 22,
  //     src: "/images/model-49.webp",
  //     title: "Mahogany-Sheen",
  //     description: "HEX #6B3A24 with broad forehead",
  //     prompt: "Cat-eye liner with faux locs",
  //   },
  //   {
  //     id: 23,
  //     src: "/images/model-23.png",
  //     title: "Honey-Olive",
  //     description: "HEX #C88D5F with button nose",
  //     prompt: "High puff hairstyle with gold stud earrings",
  //   },
  //   {
  //     id: 24,
  //     src: "/images/model-24.png",
  //     title: "Amber-Wood",
  //     description: "HEX #A05C3C with thick brows",
  //     prompt: "Cornrows with cowrie shells",
  //   },
  //   {
  //     id: 25,
  //     src: "/images/model-25.png",
  //     title: "Spiced Latte",
  //     description: "HEX #D39C6A with freckles",
  //     prompt: "Slicked-back bun with gold foil eyeliner",
  //   },
  //   {
  //     id: 26,
  //     src: "/images/model-26.png",
  //     title: "Caramel-Sunset",
  //     description: "HEX #E0A073 with monolid eyes",
  //     prompt: "High ponytail with peach gloss",
  //   },
  //   {
  //     id: 27,
  //     src: "/images/model-27.png",
  //     title: "Bronze-Clay",
  //     description: "HEX #B56A3E with sharp contour",
  //     prompt: "Twisted updo with hair pins",
  //   },
  //   {
  //     id: 28,
  //     src: "/images/model-28.png",
  //     title: "Mocha-Spice",
  //     description: "HEX #8A4B2A with rounded cheeks",
  //     prompt: "Braided crown with minimal makeup",
  //   },
  //   {
  //     id: 29,
  //     src: "/images/model-29.png",
  //     title: "Golden-Sand",
  //     description: "HEX #D18B55 with almond eyes",
  //     prompt: "Short afro with side part",
  //   },
  //   {
  //     id: 30,
  //     src: "/images/model-30.png",
  //     title: "Terra-Gold",
  //     description: "HEX #B2673E with wide smile",
  //     prompt: "Box braids with gold threads",
  //   },
  //   {
  //     id: 31,
  //     src: "/images/model-31.png",
  //     title: "Cinnamon-Matte",
  //     description: "HEX #9C5D34 with high cheekbones",
  //     prompt: "Sleek low bun with diamond studs",
  //   },
  //   {
  //     id: 32,
  //     src: "/images/model-32.png",
  //     title: "Amber-Silk",
  //     description: "HEX #C67C4D with hooded eyes",
  //     prompt: "Headwrap with curly fringe",
  //   },
  //   {
  //     id: 33,
  //     src: "/images/model-33.png",
  //     title: "Mahogany-Satin",
  //     description: "HEX #6B3A24 with full brows",
  //     prompt: "Buzz cut with henna patterns",
  //   },
  //   {
  //     id: 34,
  //     src: "/images/model-34.png",
  //     title: "Honey-Suede",
  //     description: "HEX #C88D5F with soft features",
  //     prompt: "Long braids with beads",
  //   },
  //   {
  //     id: 35,
  //     src: "/images/model-35.png",
  //     title: "Spiced-Sun",
  //     description: "HEX #D39C6A with freckled nose",
  //     prompt: "Pixie cut with side shave",
  //   },
  //   {
  //     id: 36,
  //     src: "/images/model-36.png",
  //     title: "Bronze-Clay",
  //     description: "HEX #B56A3E with sharp contour",
  //     prompt: "Twisted updo with hair pins",
  //   },
  //   {
  //     id: 37,
  //     src: "/images/model-37.png",
  //     title: "Mocha-Spice",
  //     description: "HEX #8A4B2A with rounded cheeks",
  //     prompt: "Braided crown with minimal makeup",
  //   },
  //   {
  //     id: 38,
  //     src: "/images/model-38.png",
  //     title: "Golden-Sand",
  //     description: "HEX #D18B55 with almond eyes",
  //     prompt: "Short afro with side part",
  //   },
  //   {
  //     id: 39,
  //     src: "/images/model-39.png",
  //     title: "Terra-Gold",
  //     description: "HEX #B2673E with wide smile",
  //     prompt: "Box braids with gold threads",
  //   },
  //   {
  //     id: 40,
  //     src: "/images/model-40.png",
  //     title: "Cinnamon-Matte",
  //     description: "HEX #9C5D34 with high cheekbones",
  //     prompt: "Sleek low bun with diamond studs",
  //   },
  //   {
  //     id: 41,
  //     src: "/images/model-41.png",
  //     title: "Amber-Silk",
  //     description: "HEX #C67C4D with hooded eyes",
  //     prompt: "Headwrap with curly fringe",
  //   },
  //   {
  //     id: 42,
  //     src: "/images/model-42.png",
  //     title: "Mahogany-Satin",
  //     description: "HEX #6B3A24 with full brows",
  //     prompt: "Buzz cut with henna patterns",
  //   },

  //   {
  //     id: 43,
  //     src: "/images/model-43.png",
  //     title: "Honey-Suede",
  //     description: "HEX #C88D5F with soft features",
  //     prompt: "Long braids with beads",
  //   },
  //   {
  //     id: 44,
  //     src: "/images/model-44.webp",
  //     title: "Golden Caramel Beauty",
  //     description: "HEX #B76E54 with amber undertones",
  //     prompt:
  //       "Ultra-realistic portrait with symmetrical features and satin-matte complexion",
  //   },
  //   {
  //     id: 45,
  //     src: "/images/model-45.webp",
  //     title: "Honey-Brown Elegance",
  //     description: "HEX #9C5D34 with olive undertones",
  //     prompt:
  //       "Studio portrait with butterfly lighting and professional retouching",
  //   },
  //   {
  //     id: 46,
  //     src: "/images/model-46.webp",
  //     title: "Toffee-Toned Grace",
  //     description: "HEX #7F4A33 with russet undertones",
  //     prompt: "Canon EOS R5, 85mm shot with Kodak Portra 400 simulation",
  //   },
  //   {
  //     id: 47,
  //     src: "/images/model-47.webp",
  //     title: "Mocha Warmth",
  //     description: "HEX #6B3A24 with golden highlights",
  //     prompt: "Neutral confident expression with slight head tilt",
  //   },
  //   {
  //     id: 48,
  //     src: "/images/model-48.webp",
  //     title: "Cinnamon Glow",
  //     description: "HEX #D39C6A with natural freckles",
  //     prompt: "Full lips, wide almond eyes with long lashes",
  //   },
  //   {
  //     id: 49,
  //     src: "/images/model-49.webp",
  //     title: "Amber Bronze",
  //     description: "HEX #C67C4D with hooded eyes",
  //     prompt: "Slicked-back bun hairstyle with minimal makeup",
  //   },
  //   {
  //     id: 50,
  //     src: "/images/model-24.png",
  //     title: "Mahogany Rich",
  //     description: "HEX #5E2C19 with red undertones",
  //     prompt: "Professional studio lighting with dark gray backdrop",
  //   },
  //   {
  //     id: 51,
  //     src: "/images/model-61.webp",
  //     title: "Terra-Cotta Glow",
  //     description: "HEX #A05C3C with warm undertones",
  //     prompt: "High-cheekboned portrait with glossy nude lips",
  //   },
  //   {
  //     id: 52,
  //     src: "/images/model-15.png",
  //     title: "Spiced Brown",
  //     description: "HEX #8A4B2A with golden-red undertones",
  //     prompt: "Downturned eyes with blunt bob hairstyle",
  //   },
  //   {
  //     id: 53,
  //     src: "/images/model-53.webp",
  //     title: "Golden-Red",
  //     description: "HEX #B2673E with sun-kissed glow",
  //     prompt: "Tigrayan features with golden leaf eyeliner",
  //   },
  //   {
  //     id: 54,
  //     src: "/images/model-54.webp",
  //     title: "Warm Almond",
  //     description: "HEX #C88D5F with golden-olive undertones",
  //     prompt: "Delicate nose with rosy lips and shimmering highlight",
  //   },
  //   {
  //     id: 55,
  //     src: "/images/model-55.webp",
  //     title: "Copper-Red",
  //     description: "HEX #B56A3E with freckled nose",
  //     prompt: "Deep-set eyes with extended winged liner",
  //   },
  //   {
  //     id: 56,
  //     src: "/images/model-61.webp",
  //     title: "Golden-Tan",
  //     description: "HEX #E0A073 with oval face",
  //     prompt: "Doe eyes with long lashes and half-up box braids",
  //   },
  //   {
  //     id: 57,
  //     src: "/images/model-57.webp",
  //     title: "Spiced Honey",
  //     description: "HEX #A05C3C with russet tones",
  //     prompt: "High cheekbones with blotted berry lips",
  //   },
  //   {
  //     id: 58,
  //     src: "/images/model-58.webp",
  //     title: "Caramel-Bronze",
  //     description: "HEX #D18B55 with round face",
  //     prompt: "Monolid eyes with gold shadow and voluminous afro",
  //   },
  //   {
  //     id: 59,
  //     src: "/images/model-59.webp",
  //     title: "Amber-Glow",
  //     description: "HEX #C67C4D with sharp jawline",
  //     prompt: "Headwrap with dangling amber beads",
  //   },
  //   {
  //     id: 60,
  //     src: "/images/model-60.webp",
  //     title: "Mocha-Rose",
  //     description: "HEX #8A4B2A with heart-shaped face",
  //     prompt: "Blush-heavy cheeks with micro braids",
  //   },
  //   {
  //     id: 61,
  //     src: "/images/model-61.webp",
  //     title: "Terra-Cotta",
  //     description: "HEX #B2673E with wide nose",
  //     prompt: "Stained berry lips with short curly frohawk",
  //   },
  //   {
  //     id: 62,
  //     src: "/images/model-62.webp",
  //     title: "Toffee-Cream",
  //     description: "HEX #E3B089 with epicanthic folds",
  //     prompt: "Feathered brows with long Senegalese twists",
  //   },
  // ];

  const portraits = [
    {
      id: 1,
      src: "/images/model-one.png",
      title: "Golden Caramel Beauty - Almaz Bekele",
      description: "HEX #B76E54 with amber undertones",
      prompt:
        "Ultra-realistic portrait with symmetrical features and satin-matte complexion | Earnings: $2,500/month | Location: Addis Ababa, Ethiopia",
    },
    {
      id: 2,
      src: "/images/model-50.webp",
      title: "Honey-Brown Elegance - Tigist Yohannes",
      description: "HEX #9C5D34 with olive undertones",
      prompt:
        "Studio portrait with butterfly lighting and professional retouching | Earnings: $3,200/month | Location: Nairobi, Kenya",
    },
    {
      id: 3,
      src: "/images/model-three.png",
      title: "Toffee-Toned Grace - Selamawit Tesfaye",
      description: "HEX #7F4A33 with russet undertones",
      prompt:
        "Canon EOS R5, 85mm shot with Kodak Portra 400 simulation | Earnings: $1,800/month | Location: Johannesburg, South Africa",
    },
    {
      id: 4,
      src: "/images/model-four.png",
      title: "Mocha Warmth - Frehiwot Assefa",
      description: "HEX #6B3A24 with golden highlights",
      prompt:
        "Neutral confident expression with slight head tilt | Earnings: $4,500/month | Location: Lagos, Nigeria",
    },
    {
      id: 5,
      src: "/images/model-five.png",
      title: "Cinnamon Glow - Bethlehem Girma",
      description: "HEX #D39C6A with natural freckles",
      prompt:
        "Full lips, wide almond eyes with long lashes | Earnings: $2,100/month | Location: Dar es Salaam, Tanzania",
    },
    {
      id: 6,
      src: "/images/model-six.png",
      title: "Amber Bronze - Eden Tadesse",
      description: "HEX #C67C4D with hooded eyes",
      prompt:
        "Slicked-back bun hairstyle with minimal makeup | Earnings: $3,700/month | Location: Accra, Ghana",
    },
    {
      id: 7,
      src: "/images/model-seven.png",
      title: "Mahogany Rich - Rahel Mengistu",
      description: "HEX #5E2C19 with red undertones",
      prompt:
        "Professional studio lighting with dark gray backdrop | Earnings: $2,900/month | Location: Kampala, Uganda",
    },
    {
      id: 8,
      src: "/images/model-eight.png",
      title: "Terra-Cotta Glow - Aster Abebe",
      description: "HEX #A05C3C with warm undertones",
      prompt:
        "High-cheekboned portrait with glossy nude lips | Earnings: $5,200/month | Location: New York, USA",
    },
    {
      id: 9,
      src: "/images/model-nine.png",
      title: "Spiced Brown - Kalkidan Solomon",
      description: "HEX #8A4B2A with golden-red undertones",
      prompt:
        "Downturned eyes with blunt bob hairstyle | Earnings: $1,950/month | Location: London, UK",
    },
    {
      id: 10,
      src: "/images/model-ten.png",
      title: "Golden-Red - Tsion Daniel",
      description: "HEX #B2673E with sun-kissed glow",
      prompt:
        "Tigrayan features with golden leaf eyeliner | Earnings: $3,800/month | Location: Dubai, UAE",
    },
    {
      id: 11,
      src: "/images/model-eleven.png",
      title: "Warm Almond - Genet Hailu",
      description: "HEX #C88D5F with golden-olive undertones",
      prompt:
        "Delicate nose with rosy lips and shimmering highlight | Earnings: $2,600/month | Location: Paris, France",
    },
    {
      id: 12,
      src: "/images/model-12.png",
      title: "Copper-Red - Meseret Asrat",
      description: "HEX #B56A3E with freckled nose",
      prompt:
        "Deep-set eyes with extended winged liner | Earnings: $4,100/month | Location: Toronto, Canada",
    },
    {
      id: 13,
      src: "/images/model-13.png",
      title: "Golden-Tan - Hiwot Kebede",
      description: "HEX #E0A073 with oval face",
      prompt:
        "Doe eyes with long lashes and half-up box braids | Earnings: $3,500/month | Location: Sydney, Australia",
    },
    {
      id: 14,
      src: "/images/model-14.png",
      title: "Spiced Honey - Emebet Wolde",
      description: "HEX #A05C3C with russet tones",
      prompt:
        "High cheekbones with blotted berry lips | Earnings: $2,300/month | Location: Berlin, Germany",
    },
    {
      id: 15,
      src: "/images/model-15.png",
      title: "Caramel-Bronze - Sara Getachew",
      description: "HEX #D18B55 with round face",
      prompt:
        "Monolid eyes with gold shadow and voluminous afro | Earnings: $4,800/month | Location: Los Angeles, USA",
    },
    {
      id: 16,
      src: "/images/model-16.png",
      title: "Amber-Glow - Bethlehem Assefa",
      description: "HEX #C67C4D with sharp jawline",
      prompt:
        "Headwrap with dangling amber beads | Earnings: $3,100/month | Location: Stockholm, Sweden",
    },
    {
      id: 17,
      src: "/images/model-17.png",
      title: "Mocha-Rose - Selam Tsegaye",
      description: "HEX #8A4B2A with heart-shaped face",
      prompt:
        "Blush-heavy cheeks with micro braids | Earnings: $2,700/month | Location: Milan, Italy",
    },
    {
      id: 18,
      src: "/images/model-18.png",
      title: "Terra-Cotta - Eleni Kassahun",
      description: "HEX #B2673E with wide nose",
      prompt:
        "Stained berry lips with short curly frohawk | Earnings: $5,500/month | Location: Tokyo, Japan",
    },
    {
      id: 19,
      src: "/images/model-19.png",
      title: "Toffee-Cream - Tigist Haile",
      description: "HEX #E3B089 with epicanthic folds",
      prompt:
        "Feathered brows with long Senegalese twists | Earnings: $3,900/month | Location: Cape Town, South Africa",
    },
    {
      id: 20,
      src: "/images/model-20.png",
      title: "Cinnamon-Dust - Marta Girma",
      description: "HEX #9C5D34 with downturned eyes",
      prompt:
        "Thin gold chain headpiece with matte brown lips | Earnings: $2,800/month | Location: Nairobi, Kenya",
    },
    {
      id: 21,
      src: "/images/model-21.png",
      title: "Golden-Russet - Yordanos Teshome",
      description: "HEX #B76E54 with dimpled chin",
      prompt:
        "Bantu knots with baby hairs laid | Earnings: $4,200/month | Location: Lagos, Nigeria",
    },
    {
      id: 22,
      src: "/images/model-49.webp",
      title: "Mahogany-Sheen - Hanna Mekonnen",
      description: "HEX #6B3A24 with broad forehead",
      prompt:
        "Cat-eye liner with faux locs | Earnings: $3,300/month | Location: Accra, Ghana",
    },
    {
      id: 23,
      src: "/images/model-23.png",
      title: "Honey-Olive - Ruth Abera",
      description: "HEX #C88D5F with button nose",
      prompt:
        "High puff hairstyle with gold stud earrings | Earnings: $2,400/month | Location: Addis Ababa, Ethiopia",
    },
    {
      id: 24,
      src: "/images/model-24.png",
      title: "Amber-Wood - Eden Mulugeta",
      description: "HEX #A05C3C with thick brows",
      prompt:
        "Cornrows with cowrie shells | Earnings: $4,700/month | Location: Johannesburg, South Africa",
    },
    {
      id: 25,
      src: "/images/model-25.png",
      title: "Spiced Latte - Lydia Tadesse",
      description: "HEX #D39C6A with freckles",
      prompt:
        "Slicked-back bun with gold foil eyeliner | Earnings: $3,600/month | Location: Dar es Salaam, Tanzania",
    },
    {
      id: 26,
      src: "/images/model-26.png",
      title: "Caramel-Sunset - Mimi Fikre",
      description: "HEX #E0A073 with monolid eyes",
      prompt:
        "High ponytail with peach gloss | Earnings: $2,900/month | Location: Kampala, Uganda",
    },
    {
      id: 27,
      src: "/images/model-27.png",
      title: "Bronze-Clay - Sara Hailu",
      description: "HEX #B56A3E with sharp contour",
      prompt:
        "Twisted updo with hair pins | Earnings: $5,100/month | Location: New York, USA",
    },
    {
      id: 28,
      src: "/images/model-28.png",
      title: "Mocha-Spice - Bethlehem Asnake",
      description: "HEX #8A4B2A with rounded cheeks",
      prompt:
        "Braided crown with minimal makeup | Earnings: $3,400/month | Location: London, UK",
    },
    {
      id: 29,
      src: "/images/model-29.png",
      title: "Golden-Sand - Rahel Assefa",
      description: "HEX #D18B55 with almond eyes",
      prompt:
        "Short afro with side part | Earnings: $2,200/month | Location: Dubai, UAE",
    },
    {
      id: 30,
      src: "/images/model-30.png",
      title: "Terra-Gold - Tsigereda Bekele",
      description: "HEX #B2673E with wide smile",
      prompt:
        "Box braids with gold threads | Earnings: $4,900/month | Location: Paris, France",
    },
    {
      id: 31,
      src: "/images/model-31.png",
      title: "Cinnamon-Matte - Mahlet Girma",
      description: "HEX #9C5D34 with high cheekbones",
      prompt:
        "Sleek low bun with diamond studs | Earnings: $3,700/month | Location: Toronto, Canada",
    },
    {
      id: 32,
      src: "/images/model-32.png",
      title: "Amber-Silk - Selamawit Abebe",
      description: "HEX #C67C4D with hooded eyes",
      prompt:
        "Headwrap with curly fringe | Earnings: $2,500/month | Location: Sydney, Australia",
    },
    {
      id: 33,
      src: "/images/model-33.png",
      title: "Mahogany-Satin - Kalkidan Tadesse",
      description: "HEX #6B3A24 with full brows",
      prompt:
        "Buzz cut with henna patterns | Earnings: $4,300/month | Location: Berlin, Germany",
    },
    {
      id: 34,
      src: "/images/model-34.png",
      title: "Honey-Suede - Eden Yohannes",
      description: "HEX #C88D5F with soft features",
      prompt:
        "Long braids with beads | Earnings: $3,800/month | Location: Los Angeles, USA",
    },
    {
      id: 35,
      src: "/images/model-35.png",
      title: "Spiced-Sun - Tigist Mulugeta",
      description: "HEX #D39C6A with freckled nose",
      prompt:
        "Pixie cut with side shave | Earnings: $2,600/month | Location: Stockholm, Sweden",
    },
    {
      id: 36,
      src: "/images/model-36.png",
      title: "Bronze-Clay - Marta Tesfaye",
      description: "HEX #B56A3E with sharp contour",
      prompt:
        "Twisted updo with hair pins | Earnings: $5,000/month | Location: Milan, Italy",
    },
    {
      id: 37,
      src: "/images/model-37.png",
      title: "Mocha-Spice - Selam Daniel",
      description: "HEX #8A4B2A with rounded cheeks",
      prompt:
        "Braided crown with minimal makeup | Earnings: $3,900/month | Location: Tokyo, Japan",
    },
    {
      id: 38,
      src: "/images/model-38.png",
      title: "Golden-Sand - Hiwot Kassahun",
      description: "HEX #D18B55 with almond eyes",
      prompt:
        "Short afro with side part | Earnings: $2,700/month | Location: Cape Town, South Africa",
    },
    {
      id: 39,
      src: "/images/model-39.png",
      title: "Terra-Gold - Emebet Haile",
      description: "HEX #B2673E with wide smile",
      prompt:
        "Box braids with gold threads | Earnings: $4,600/month | Location: Nairobi, Kenya",
    },
    {
      id: 40,
      src: "/images/model-40.png",
      title: "Cinnamon-Matte - Sara Teshome",
      description: "HEX #9C5D34 with high cheekbones",
      prompt:
        "Sleek low bun with diamond studs | Earnings: $3,500/month | Location: Lagos, Nigeria",
    },
    {
      id: 41,
      src: "/images/model-41.png",
      title: "Amber-Silk - Ruth Mekonnen",
      description: "HEX #C67C4D with hooded eyes",
      prompt:
        "Headwrap with curly fringe | Earnings: $2,300/month | Location: Accra, Ghana",
    },
    {
      id: 42,
      src: "/images/model-42.png",
      title: "Mahogany-Satin - Eden Abera",
      description: "HEX #6B3A24 with full brows",
      prompt:
        "Buzz cut with henna patterns | Earnings: $4,800/month | Location: Addis Ababa, Ethiopia",
    },
    {
      id: 43,
      src: "/images/model-43.png",
      title: "Honey-Suede - Mimi Mulugeta",
      description: "HEX #C88D5F with soft features",
      prompt:
        "Long braids with beads | Earnings: $3,600/month | Location: Johannesburg, South Africa",
    },
    {
      id: 44,
      src: "/images/model-39.png",
      title: "Golden Caramel Beauty - Rahel Fikre",
      description: "HEX #B76E54 with amber undertones",
      prompt:
        "Ultra-realistic portrait with symmetrical features and satin-matte complexion | Earnings: $2,800/month | Location: Dar es Salaam, Tanzania",
    },
    {
      id: 45,
      src: "/images/pic-edit-6.png",
      title: "Honey-Brown Elegance - Tsion Hailu",
      description: "HEX #9C5D34 with olive undertones",
      prompt:
        "Studio portrait with butterfly lighting and professional retouching | Earnings: $5,300/month | Location: Kampala, Uganda",
    },
    {
      id: 46,
      src: "/images/model-46.webp",
      title: "Toffee-Toned Grace - Mahlet Asnake",
      description: "HEX #7F4A33 with russet undertones",
      prompt:
        "Canon EOS R5, 85mm shot with Kodak Portra 400 simulation | Earnings: $3,700/month | Location: New York, USA",
    },
    {
      id: 47,
      src: "/images/model-47.webp",
      title: "Mocha Warmth - Kalkidan Yohannes",
      description: "HEX #6B3A24 with golden highlights",
      prompt:
        "Neutral confident expression with slight head tilt | Earnings: $2,400/month | Location: London, UK",
    },
    {
      id: 48,
      src: "/images/model-48.webp",
      title: "Cinnamon Glow - Tigist Daniel",
      description: "HEX #D39C6A with natural freckles",
      prompt:
        "Full lips, wide almond eyes with long lashes | Earnings: $4,100/month | Location: Dubai, UAE",
    },
    {
      id: 49,
      src: "/images/model-49.webp",
      title: "Amber Bronze - Selamawit Bekele",
      description: "HEX #C67C4D with hooded eyes",
      prompt:
        "Slicked-back bun hairstyle with minimal makeup | Earnings: $3,200/month | Location: Paris, France",
    },
    {
      id: 50,
      src: "/images/model-24.png",
      title: "Mahogany Rich - Genet Tadesse",
      description: "HEX #5E2C19 with red undertones",
      prompt:
        "Professional studio lighting with dark gray backdrop | Earnings: $5,400/month | Location: Toronto, Canada",
    },
    {
      id: 51,
      src: "/images/model-61.webp",
      title: "Terra-Cotta Glow - Hiwot Wolde",
      description: "HEX #A05C3C with warm undertones",
      prompt:
        "High-cheekboned portrait with glossy nude lips | Earnings: $3,900/month | Location: Sydney, Australia",
    },
    {
      id: 52,
      src: "/images/model-15.png",
      title: "Spiced Brown - Emebet Getachew",
      description: "HEX #8A4B2A with golden-red undertones",
      prompt:
        "Downturned eyes with blunt bob hairstyle | Earnings: $2,500/month | Location: Berlin, Germany",
    },
    {
      id: 53,
      src: "/images/model-53.webp",
      title: "Golden-Red - Sara Assefa",
      description: "HEX #B2673E with sun-kissed glow",
      prompt:
        "Tigrayan features with golden leaf eyeliner | Earnings: $4,700/month | Location: Los Angeles, USA",
    },
    {
      id: 54,
      src: "/images/model-54.webp",
      title: "Warm Almond - Ruth Tsegaye",
      description: "HEX #C88D5F with golden-olive undertones",
      prompt:
        "Delicate nose with rosy lips and shimmering highlight | Earnings: $3,400/month | Location: Stockholm, Sweden",
    },
    {
      id: 55,
      src: "/images/model-55.webp",
      title: "Copper-Red - Eden Kassahun",
      description: "HEX #B56A3E with freckled nose",
      prompt:
        "Deep-set eyes with extended winged liner | Earnings: $2,900/month | Location: Milan, Italy",
    },
    {
      id: 56,
      src: "/images/model-61.webp",
      title: "Golden-Tan - Mimi Haile",
      description: "HEX #E0A073 with oval face",
      prompt:
        "Doe eyes with long lashes and half-up box braids | Earnings: $5,100/month | Location: Tokyo, Japan",
    },
    {
      id: 57,
      src: "/images/model-57.webp",
      title: "Spiced Honey - Rahel Girma",
      description: "HEX #A05C3C with russet tones",
      prompt:
        "High cheekbones with blotted berry lips | Earnings: $3,600/month | Location: Cape Town, South Africa",
    },
    {
      id: 58,
      src: "/images/model-58.webp",
      title: "Caramel-Bronze - Tsion Teshome",
      description: "HEX #D18B55 with round face",
      prompt:
        "Monolid eyes with gold shadow and voluminous afro | Earnings: $2,700/month | Location: Nairobi, Kenya",
    },
    {
      id: 59,
      src: "/images/model-59.webp",
      title: "Amber-Glow - Mahlet Mekonnen",
      description: "HEX #C67C4D with sharp jawline",
      prompt:
        "Headwrap with dangling amber beads | Earnings: $4,900/month | Location: Lagos, Nigeria",
    },
    {
      id: 60,
      src: "/images/model-60.webp",
      title: "Mocha-Rose - Kalkidan Abera",
      description: "HEX #8A4B2A with heart-shaped face",
      prompt:
        "Blush-heavy cheeks with micro braids | Earnings: $3,800/month | Location: Accra, Ghana",
    },
    {
      id: 61,
      src: "/images/model-61.webp",
      title: "Terra-Cotta - Tigist Mulugeta",
      description: "HEX #B2673E with wide nose",
      prompt:
        "Stained berry lips with short curly frohawk | Earnings: $2,600/month | Location: Addis Ababa, Ethiopia",
    },
    {
      id: 62,
      src: "/images/model-62.webp",
      title: "Toffee-Cream - Selam Fikre",
      description: "HEX #E3B089 with epicanthic folds",
      prompt:
        "Feathered brows with long Senegalese twists | Earnings: $5,200/month | Location: Johannesburg, South Africa",
    },
    {
      id: 63,
      src: "/images/model-64.webp",
      title: "Toffee-Cream - Rosa Tesma",
      description: "HEX #HEX3B089 with epicanthic folds",
      prompt:
        "Feathered brows with long Senegalese twists | Earnings: $4,200/month | Location: Derban, South Africa",
    },
    {
      id: 64,
      src: "/images/model-65.webp",
      title: "Gold-Cream - Fikerte Mulugeta",
      description: "HEX #E3B089 with epicanthic folds",
      prompt:
        "Feathered brows with long Senegalese twists | Earnings: $3,200/month | Location: Duba, UAE",
    },
    {
      id: 65,
      src: "/images/model-66.webp",
      title: "Coffee-Cream - Menene Gizachew",
      description: "HEX #E3B089 with epicanthic folds plus",
      prompt:
        "Feathered brows with long Senegalese twists | Earnings: $3,800/month | Location: Istanbul, Turkiye",
    },
    {
      id: 66,
      src: "/images/model-67.webp",
      title: "Coffee-Cream - Mahlet Getachew",
      description: "HEX #E3B089 with epicanthic folds plus",
      prompt:
        "Feathered brows with long Senegalese twists | Earnings: $4,800/month | Location: Istanbul, Turkiye",
    },
  ];

  // // Testimonial about Lucy Talent Scout Service
  // const testimonial = {
  //   name: "Alemnesh Tekle",
  //   role: "Model & Actress",
  //   quote:
  //     "Lucy Talent Scout completely transformed my career! Their professional guidance and industry connections helped me secure international modeling contracts I never dreamed possible. Within just 6 months of signing with them, I went from local fashion shows to working with major brands in Europe and the Middle East. Their team understands the unique beauty of Ethiopian features and knows exactly how to market them globally. The personalized coaching in posing, runway walking, and portfolio development was invaluable. Thanks to Lucy Talent Scout, I'm now earning 10x what I made before and living my dream!",
  //   rating: 5,
  // };
  // Preload images more efficiently
  useEffect(() => {
    let isMounted = true;

    const loadImages = async () => {
      try {
        // First load critical images (first 3 for initial display)
        const initialImages = portraits.slice(0, 3).map((p) => p.src);
        await preloadImages(initialImages);

        if (isMounted) {
          setImagesLoaded(true); // Show UI after initial images load
        }

        // Then load the rest in the background
        const remainingImages = portraits.slice(3).map((p) => p.src);
        await preloadImages(remainingImages);
      } catch (error) {
        console.error("Image preloading error:", error);
        if (isMounted) setImagesLoaded(true); // Show UI even if some images fail
      }
    };

    loadImages();

    return () => {
      isMounted = false; // Cleanup to prevent state updates after unmount
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openModal = (portrait) => {
    setSelectedPortrait(portrait);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  if (!imagesLoaded) {
    return (
      <section className="py-12 md:py-16 bg-gradient-to-b from-gray-900 to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-yellow-400 mb-4"></div>
          <p className="text-white">Loading portraits...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-3 text-white">
            <span className="text-yellow-400">Habesha Beauty</span> Showcase
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto text-sm md:text-base">
            Ultra-realistic studio portraits featuring diverse Ethiopian beauty
          </p>
        </div>

        <div className="relative">
          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            navigation={{
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            }}
            className="pb-12"
          >
            {portraits.map((portrait) => (
              <SwiperSlide key={portrait.id}>
                <motion.div
                  className="bg-white rounded-xl overflow-hidden shadow-xl h-full"
                  whileHover={{ y: -10 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="relative h-64 md:h-80 w-full group">
                    <LazyLoadImage
                      src={portrait.src}
                      alt={portrait.title}
                      className="w-full h-full object-cover  object-[center_20%]"
                      effect="blur"
                      placeholderSrc={portrait.placeholder}
                      width="100%"
                      height="100%"
                      loading="eager" // Force eager loading for first few images
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = portrait.placeholder;
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent flex items-end p-4">
                      <div>
                        <h3 className="text-white font-bold text-lg md:text-xl">
                          {portrait.title}
                        </h3>
                        <p className="text-yellow-200 text-sm">
                          {portrait.description}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() => openModal(portrait)}
                      className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                      aria-label="View portrait in full screen"
                    >
                      <FaExpand className="text-sm" />
                    </button>
                  </div>
                  <div className="p-4 md:p-6 bg-gray-50">
                    <p className="text-gray-600 text-xs md:text-sm italic">
                      "{portrait.prompt}"
                    </p>
                    <div className="mt-3 flex justify-between items-center">
                      <span className="text-xs text-gray-500">
                        Lucy-Talent Portrait
                      </span>
                      <button
                        onClick={() => openModal(portrait)}
                        className="text-yellow-600 hover:text-yellow-700 text-xs font-medium flex items-center"
                      >
                        View Portrait
                      </button>
                    </div>
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation */}
          <button className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full ml-2">
            <FaChevronLeft />
          </button>
          <button className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full mr-2">
            <FaChevronRight />
          </button>
        </div>

        <div className="text-center mt-6">
          <p className="text-gray-400 text-sm max-w-2xl mx-auto">
            Each portrait is taken by Lucy Talent professional photographer to
            highlight the diverse beauty of Ethiopian women across different
            skin tones.
          </p>
        </div>

        {/* Fullscreen Modal */}
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Portrait View"
          className="modal"
          overlayClassName="modal-overlay"
        >
          {selectedPortrait && (
            <div className="relative h-full w-full flex flex-col">
              <div className="flex-grow flex items-center justify-center p-4">
                <img
                  src={selectedPortrait.src}
                  alt={selectedPortrait.title}
                  className="max-h-full max-w-full object-contain"
                  loading="eager"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = selectedPortrait.placeholder;
                  }}
                />
              </div>
              <div className="bg-white p-4 md:p-6">
                <h3 className="font-bold text-lg md:text-xl">
                  {selectedPortrait.title}
                </h3>
                <p className="text-yellow-600 text-sm md:text-base">
                  {selectedPortrait.description}
                </p>
                <p className="text-gray-600 mt-2 text-sm md:text-base italic">
                  "{selectedPortrait.prompt}"
                </p>
              </div>
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full"
                aria-label="Close modal"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          )}
        </Modal>
      </div>

      {/* Modal Styles */}
      <style jsx global>{`
        .modal {
          position: fixed;
          top: 50%;
          left: 50%;
          right: auto;
          bottom: auto;
          transform: translate(-50%, -50%);
          background: transparent;
          padding: 0;
          border: none;
          width: 90%;
          max-width: 800px;
          height: 90vh;
          max-height: 800px;
          outline: none;
        }

        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.9);
          z-index: 1000;
        }

        @media (max-width: 768px) {
          .modal {
            width: 95%;
            height: 80vh;
          }
        }
      `}</style>
    </section>
  );
};

function Hero() {
  const cities = [
    { name: "DUBAI", key: "dubai", tagline: "Where Dreams Become Reality" },
    { name: "ISTANBUL", key: "istanbul", tagline: "East Meets West" },
    { name: "MOSCOW", key: "moscow", tagline: "The Ultimate Stage" },
    { name: "MIAMI", key: "miami", tagline: "American Dream Awaits" },
    { name: "BEIJING", key: "beijing", tagline: "Ancient Meets Modern" },
  ];

  useEffect(() => {
    Object.values(dummyImages).forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const [currentCity, setCurrentCity] = useState(0);
  const [scrollIndicatorVisible, setScrollIndicatorVisible] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCity((prev) => (prev + 1) % cities.length);
      setImageLoaded(false);
    }, 5000);
    return () => clearInterval(interval);
  }, [cities.length]);

  useEffect(() => {
    const handleScroll = () => {
      setScrollIndicatorVisible(window.scrollY <= 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <section className="relative h-screen bg-gradient-to-b from-gray-900 to-gray-800 overflow-hidden">
      {/* Background image with dark overlay - Responsive adjustments */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" />
        <AnimatePresence mode="wait">
          <motion.img
            key={cities[currentCity].key}
            src={dummyImages[cities[currentCity].key]}
            alt={`${cities[currentCity].name} nightlife`}
            className="w-full h-full object-cover sm:object-center md:object-left-top"
            initial={{ opacity: 0 }}
            animate={{ opacity: imageLoaded ? 1 : 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            onLoad={handleImageLoad}
            loading="eager"
          />
        </AnimatePresence>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 h-full flex flex-col justify-center items-center text-center text-white px-4 sm:px-6"
      >
        <div className="mb-4 sm:mb-6 md:mb-8 w-full max-w-4xl">
          <motion.div
            className="inline-block bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 py-1 sm:px-5 sm:py-1.5 md:px-6 md:py-2 rounded-full md:mt-14 mb-3 sm:mb-4 md:mb-6 shadow-lg"
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{
              repeat: Infinity,
              repeatType: "reverse",
              duration: 1.5,
            }}
          >
            <span className="flex items-center font-semibold tracking-wide text-xs sm:text-sm md:text-base">
              <FaGlobeAmericas className="mr-1 sm:mr-2" /> LUCY TALENT SCOUT
            </span>
          </motion.div>

          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 md:mb-6 leading-tight">
            <span className="text-yellow-400">
              Say Yes—The World Awaits You
            </span>
            <br />
            <motion.span
              key={cities[currentCity].name}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.7 }}
              className="block mt-2 sm:mt-3 md:mt-4 text-xl sm:text-2xl md:text-3xl"
            >
              Your Gateway to {cities[currentCity].name} Nightlife
            </motion.span>
          </h1>
          <motion.p
            key={`tagline-${cities[currentCity].key}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="text-base sm:text-lg md:text-xl text-yellow-200 italic"
          >
            {cities[currentCity].tagline}
          </motion.p>
        </div>

        <div className="w-full max-w-4xl">
          <ScarcityBadge />
          <CountdownTimer />
        </div>

        <motion.div
          className="mb-6 sm:mb-8 md:mb-12 w-full max-w-2xl mx-auto bg-black/40 p-4 sm:p-6 md:p-8 rounded-xl border border-yellow-400/30 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <p className="mb-2 sm:mb-3 md:mb-4 italic text-sm sm:text-base md:text-lg">
            "When you imagine yourself performing in {cities[currentCity].name},
            you can{" "}
            <span className="font-bold text-yellow-300">
              feel the excitement
            </span>{" "}
            building inside you..."
          </p>
          <p className="mb-3 sm:mb-4 md:mb-6 italic text-sm sm:text-base md:text-lg">
            "The selected few experience{" "}
            <span className="font-bold text-yellow-300">
              Visa Sponsorship • $4K+ Monthly • Luxury Accommodation
            </span>
            "
          </p>
          <motion.a
            href="#apply"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-block bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-2 sm:py-3 px-6 sm:px-8 md:py-3 md:px-10 rounded-full text-sm sm:text-base md:text-lg transition-all shadow-lg hover:shadow-xl"
          >
            Begin Your Journey Now
          </motion.a>
        </motion.div>

        {scrollIndicatorVisible && (
          // <motion.div
          //   className="absolute bottom-4 sm:bottom-6 md:bottom-8 left-1/2 transform -translate-x-1/2"
          //   animate={{ y: [0, 10, 0] }}
          //   transition={{ repeat: Infinity, duration: 2 }}
          // >
          //   <div className="flex flex-col items-center ">
          //     <p className="text-xs sm:text-sm mb-1 sm:mb-2 text-white/80">
          //       Discover More
          //     </p>
          //     <div className="w-5 h-8 sm:w-6 sm:h-10 border-2 border-yellow-400 rounded-full flex justify-center">
          //       <motion.div
          //         className="w-1 h-2 bg-yellow-400 rounded-full mt-1 sm:mt-2"
          //         animate={{ y: [0, 4, 0] }}
          //         transition={{ repeat: Infinity, duration: 1.5 }}
          //       />
          //     </div>
          //   </div>
          // </motion.div>
          <motion.div
            className="absolute bottom-4 sm:bottom-6 md:bottom-8 inset-x-0 mx-auto w-fit"
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 2 }}
          >
            <div className="flex flex-col items-center">
              <p className="text-xs sm:text-sm mb-1 sm:mb-2 text-white/80">
                Discover More
              </p>
              <div className="w-5 h-8 sm:w-6 sm:h-10 border-2 border-yellow-400 rounded-full flex justify-center">
                <motion.div
                  className="w-1 h-2 bg-yellow-400 rounded-full mt-1 sm:mt-2"
                  animate={{ y: [0, 4, 0] }}
                  transition={{ repeat: Infinity, duration: 1.5 }}
                />
              </div>
            </div>
          </motion.div>
        )}
      </motion.div>
    </section>
  );
}

function ScarcityBadge() {
  return (
    <motion.div
      className="inline-flex items-center bg-black/80 border border-yellow-400 rounded-full px-4 py-1 md:px-6 md:py-2 mb-4 md:mb-8 shadow-lg"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <span className="relative flex h-2 w-2 md:h-3 md:w-3 mr-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 md:h-3 md:w-3 bg-red-600" />
      </span>
      <span className="font-medium tracking-wide text-xs md:text-sm">
        LIMITED 2025 INTAKE - FEW SPOTS LEFT
      </span>
    </motion.div>
  );
}

function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 3,
    hours: 7,
    minutes: 33,
    seconds: 11,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        const seconds = prev.seconds - 1;
        const minutes = seconds < 0 ? prev.minutes - 1 : prev.minutes;
        const hours = minutes < 0 ? prev.hours - 1 : prev.hours;
        const days = hours < 0 ? prev.days - 1 : prev.days;

        return {
          days: days >= 0 ? days : 0,
          hours: hours >= 0 ? hours : 23,
          minutes: minutes >= 0 ? minutes : 59,
          seconds: seconds >= 0 ? seconds : 59,
        };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex items-center justify-center gap-2 md:gap-4 mt-4 md:mt-6  mb-7 md:mb-4">
      {Object.entries(timeLeft).map(([unit, value]) => (
        <motion.div
          key={unit}
          className="text-center"
          whileHover={{ scale: 1.05 }}
        >
          <div className="text-xl md:text-5xl font-bold bg-black/50 rounded-lg px-2 py-1 md:px-4 md:py-2">
            {value.toString().padStart(2, "0")}
          </div>
          <div className="text-xs uppercase tracking-wider mt-1">{unit}</div>
        </motion.div>
      ))}
    </div>
  );
}

// New Transformation Section with Before/After Psychological Contrast

// Ultra-Premium Benefits Section with Psychological Triggers
function BenefitsSections() {
  const benefits = [
    {
      icon: (
        <FaMoneyBillWave className="text-2xl md:text-3xl text-yellow-500" />
      ),
      title: "Elite-Level Earnings",
      description: "$3,000 - $10,000 monthly with performance bonuses",
      highlight: "Top 10% earners make $15K+ with our premium placements",
      psychologicalTrigger:
        "Anchor to high numbers to make standard offers seem more reasonable",
    },
    {
      icon: <FaPassport className="text-2xl md:text-3xl text-yellow-500" />,
      title: "Visa Mastery",
      description: "Full visa processing with 95% approval rate",
      highlight: "We've successfully processed 62 visas this year",
      psychologicalTrigger: "Social proof through specific numbers",
    },
    {
      icon: <FaHome className="text-2xl md:text-3xl text-yellow-500" />,
      title: "Luxury Living",
      description: "Premium accommodations in exclusive neighborhoods",
      highlight: "All utilities, WiFi, and cleaning services included",
      psychologicalTrigger: "Luxury positioning creates aspirational desire",
    },
    {
      icon: <FaPlane className="text-2xl md:text-3xl text-yellow-500" />,
      title: "Global Mobility",
      description: "Perform in multiple international destinations",
      highlight: "Some contracts include all-expenses-paid international tours",
      psychologicalTrigger: "Appeal to sense of adventure and status",
    },
  ];

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4">
            Why <span className="text-yellow-500">Top 1%</span> Talents Choose
            Us
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            We provide the complete ecosystem for international success
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 hover:border-yellow-300 transition-all group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{
                y: -10,
                boxShadow:
                  "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              }}
            >
              <div className="p-4 md:p-6">
                <div className="flex justify-center mb-3 md:mb-4">
                  <div className="bg-yellow-100 p-3 md:p-4 rounded-full group-hover:rotate-12 transition-transform">
                    {benefit.icon}
                  </div>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-center mb-2 md:mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-center mb-3 md:mb-4 text-sm md:text-base">
                  {benefit.description}
                </p>
                <p className="text-xs md:text-sm text-yellow-600 font-medium text-center bg-yellow-50 px-2 py-1 md:px-3 md:py-1.5 rounded-full inline-block">
                  {benefit.highlight}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Psychological trigger: Contrast principle */}
        <div className="mt-12 md:mt-16 bg-black text-white rounded-xl p-6 md:p-12 max-w-5xl mx-auto relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')] bg-cover opacity-10"></div>
          <div className="relative z-10">
            <div className="flex flex-col md:flex-row items-center">
              <div className="md:w-1/3 mb-4 md:mb-0 flex justify-center">
                <div className="bg-yellow-500 text-black rounded-full p-4 md:p-6">
                  <FaRegLightbulb className="text-3xl md:text-4xl" />
                </div>
              </div>
              <div className="md:w-2/3 text-center md:text-left mt-4 md:mt-0">
                <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-yellow-400">
                  The Elite Talent Difference
                </h3>
                <p className="text-base md:text-lg mb-3 md:mb-4">
                  While ordinary agencies just find you work, we craft{" "}
                  <span className="text-yellow-400 font-semibold">
                    complete lifestyle transformations
                  </span>
                  . Our holistic approach means we don't just place you abroad -
                  we ensure you thrive.
                </p>
                <p className="text-gray-300 text-sm md:text-base">
                  "The quality of your life is determined by the quality of your
                  decisions. Choosing Elite Talent is the first step toward an
                  extraordinary future."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// Enhanced Testimonials Component with Psychological Triggers
function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: "Mariam Alemu",
      role: "White Dubai Dancer",
      quote:
        "Signed through Lucy Talent Scouts, I walked for 3 designers in Dubai within 6 months",
      earnings: "$5,000/month",
      visa: "UAE Work Visa",
      image: dummyImages.ethiopianModel1,
      duration: "8 months",
    },
    {
      id: 2,
      name: "Yedidiya Kebede",
      role: "Model in Istanbul",
      quote:
        "Lucy Talent Scouts got me signed with IMG Models—my life changed in one meeting",
      earnings: "$6,500/month",
      visa: "Turkish Artist Visa",
      image: dummyImages.ethiopianModel2,
      duration: "1 year",
    },
    {
      id: 3,
      name: "Selam Getachew",
      role: "Moscow Club Dancer",
      quote:
        "They handled all my visa paperwork. Earn €5K monthly with free apartment and international travel opportunities!",
      earnings: "€5,000/month",
      visa: "Russian Work Permit",
      image: dummyImages.ethiopianModel3,
      duration: "6 months",
    },
  ];

  const swiperRef = useRef(null);

  return (
    <section className="py-12 md:py-20 bg-gray-900 relative">
      <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')] bg-cover bg-center" />
      <div className="container mx-auto px-4 relative">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 text-yellow-400">
            Success Stories From Our Talents
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto">
            Hear from performers who transformed their careers through our
            program.
          </p>
        </div>

        <div className="relative">
          <button
            onClick={() => swiperRef.current?.swiper.slidePrev()}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-2 md:p-3 rounded-full ml-1 md:ml-0"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={() => swiperRef.current?.swiper.slideNext()}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white p-2 md:p-3 rounded-full mr-1 md:mr-0"
          >
            <FaChevronRight />
          </button>

          <Swiper
            ref={swiperRef}
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            autoplay={{ delay: 8000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            navigation={{
              prevEl: ".swiper-button-prev",
              nextEl: ".swiper-button-next",
            }}
            className="pb-12 md:pb-16"
            breakpoints={{
              768: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 1,
              },
            }}
          >
            {testimonials.map((testimonial) => (
              <SwiperSlide key={testimonial.id}>
                <TestimonialCard {...testimonial} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <SocialProofTicker />
      </div>
    </section>
  );
}

function TestimonialCard({
  name,
  role,
  quote,
  earnings,
  visa,
  image,
  duration,
}) {
  return (
    <div className="bg-black/50 rounded-xl overflow-hidden backdrop-blur-sm border border-gray-700/50">
      <div className="flex flex-col md:flex-row">
        <div className="md:w-2/5 bg-gray-800 flex items-center justify-center p-4 md:p-8 relative">
          <div className="relative w-full h-48 md:h-96">
            <img
              src={image}
              alt={name}
              className="w-full h-full object-cover rounded-lg object-[center_20%]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex items-end p-4 md:p-6">
              <div className="text-white">
                <p className="font-bold text-lg md:text-xl">{name}</p>
                <p className="text-yellow-400 text-sm md:text-base">{role}</p>
                <p className="text-xs text-gray-300 mt-1 md:mt-2">
                  {duration} with us
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-3/5 p-4 md:p-8 flex flex-col justify-center">
          <FaQuoteLeft className="text-yellow-400 text-3xl md:text-4xl mb-4 md:mb-6 opacity-30" />
          <p className="text-base md:text-xl text-white italic mb-6 md:mb-8 font-medium">
            {quote}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-4 md:mb-6">
            <div className="bg-yellow-500/10 p-3 md:p-4 rounded-lg border border-yellow-400/30">
              <p className="text-xs md:text-sm text-yellow-400">
                Monthly Earnings
              </p>
              <p className="font-bold text-white text-base md:text-lg">
                {earnings}
              </p>
            </div>
            <div className="bg-yellow-500/10 p-3 md:p-4 rounded-lg border border-yellow-400/30">
              <p className="text-xs md:text-sm text-yellow-400">Visa Status</p>
              <p className="font-bold text-white text-base md:text-lg">
                {visa}
              </p>
            </div>
            <div className="bg-yellow-500/10 p-3 md:p-4 rounded-lg border border-yellow-400/30">
              <p className="text-xs md:text-sm text-yellow-400">
                Contract Duration
              </p>
              <p className="font-bold text-white text-base md:text-lg">
                {duration}
              </p>
            </div>
          </div>

          {/* Ross Jeffries Principle: Future Pacing with Sensory Language */}
          <div className="bg-black/30 p-3 md:p-4 rounded-lg border border-yellow-400/20">
            <p className="text-yellow-400 text-xs md:text-sm italic font-medium">
              "Can you imagine yourself feeling this excited about your new life
              abroad? That excitement grows stronger each day as you perform for
              international audiences..."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function SocialProofTicker() {
  const stats = [
    { label: "Talents Placed", value: "87+" },
    { label: "Visa Approvals", value: "62" },
    { label: "Partner Venues", value: "23" },
    { label: "Countries", value: "8" },
    { label: "Avg Monthly Earnings", value: "$4K+" },
    { label: "Success Rate", value: "92%" },
  ];

  return (
    <div className="mt-8 md:mt-12 border-t border-b border-yellow-400/30 py-4 md:py-6">
      <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 lg:gap-16">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.label}
            className="text-center px-2"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <div className="text-xl md:text-3xl font-bold text-yellow-400">
              {stat.value}
            </div>
            <div className="text-xs md:text-sm uppercase text-white tracking-wider">
              {stat.label}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

// Ultra-Premium Process Timeline Component
function ProcessTimeline() {
  const steps = [
    {
      title: "Portfolio Review",
      description: "Our elite scouts evaluate your potential within 24 hours",
      icon: <FaCheck className="text-white" />,
      psychologicalTrigger: "Urgency through fast turnaround time",
    },
    {
      title: "Video Interview",
      description: "Personal consultation with our talent director",
      icon: <FaVideo className="text-white" />,
      psychologicalTrigger: "Personal connection builds trust",
    },
    {
      title: "Visa Processing",
      description: "Our legal team handles all paperwork and approvals",
      icon: <FaPassport className="text-white" />,
      psychologicalTrigger: "Reduces anxiety about complex process",
    },
    {
      title: "Contract Signing",
      description: "Secure your position with premium agreement",
      icon: <FaRegHandshake className="text-white" />,
      psychologicalTrigger: "Commitment and consistency principle",
    },
    {
      title: "Luxury Relocation",
      description: "We arrange everything from flights to your new home",
      icon: <FaPlane className="text-white" />,
      psychologicalTrigger: "Complete solution reduces friction",
    },
  ];

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4">
            Our Exclusive <span className="text-yellow-500">5-Step</span>{" "}
            Process
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            From application to international stage in as little as 3 weeks
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden md:block absolute left-1/2 top-0 h-full w-0.5 bg-gray-200 transform -translate-x-1/2" />

          <div className="space-y-8 md:space-y-0">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                className="flex flex-col md:flex-row items-center md:items-start relative"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                {/* For even items (right side) */}
                {index % 2 === 0 ? (
                  <>
                    <div className="hidden md:block md:w-1/2"></div>
                    {/* Timeline dot */}
                    <div className="hidden md:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 md:w-8 md:h-8 bg-yellow-500 rounded-full items-center justify-center z-10 shadow-lg">
                      {step.icon}
                    </div>
                    <div className="md:w-1/2 md:pl-8 lg:pl-12">
                      <div className="bg-gray-50 p-4 md:p-6 rounded-xl shadow-sm border border-gray-100 hover:border-yellow-300 transition-all">
                        <h3 className="text-lg md:text-xl font-bold mb-2">
                          {step.title}
                        </h3>
                        <p className="text-gray-600 text-sm md:text-base">
                          {step.description}
                        </p>
                        <div className="mt-3 md:mt-4 text-yellow-600 font-medium flex items-center">
                          <span className="bg-yellow-100 px-2 py-1 rounded-full text-xs">
                            Step {index + 1}/{steps.length}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="md:w-1/2 md:pr-8 lg:pr-12 md:text-right">
                      <div className="bg-gray-50 p-4 md:p-6 rounded-xl shadow-sm border border-gray-100 hover:border-yellow-300 transition-all">
                        <h3 className="text-lg md:text-xl font-bold mb-2">
                          {step.title}
                        </h3>
                        <p className="text-gray-600 text-sm md:text-base">
                          {step.description}
                        </p>
                        <div className="mt-3 md:mt-4 text-yellow-600 font-medium flex items-center justify-end">
                          <span className="bg-yellow-100 px-2 py-1 rounded-full text-xs">
                            Step {index + 1}/{steps.length}
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* Timeline dot */}
                    <div className="hidden md:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 md:w-8 md:h-8 bg-yellow-500 rounded-full items-center justify-center z-10 shadow-lg">
                      {step.icon}
                    </div>
                    <div className="hidden md:block md:w-1/2"></div>
                  </>
                )}

                {/* Mobile dot */}
                <div className="md:hidden flex my-3 w-6 h-6 md:w-8 md:h-8 bg-yellow-500 rounded-full items-center justify-center z-10 shadow-lg">
                  {step.icon}
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* CTA Section with psychological triggers */}
        <div className="mt-12 md:mt-16 text-center">
          <motion.div
            className="max-w-2xl mx-auto bg-gradient-to-r from-yellow-500 to-yellow-600 p-0.5 rounded-full mb-4 md:mb-6"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-full px-6 py-1 md:px-8 md:py-1">
              <p className="text-yellow-600 font-bold text-sm md:text-base">
                Limited Availability
              </p>
            </div>
          </motion.div>

          <motion.a
            href="#apply"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-block bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-3 px-8 md:py-4 md:px-10 rounded-full text-base md:text-lg transition-all shadow-lg hover:shadow-xl"
          >
            Secure Your Spot Now
          </motion.a>
          <p className="mt-2 md:mt-4 text-gray-500 text-xs md:text-sm">
            Only 3 spots remaining for our next intake
          </p>
        </div>
      </div>
    </section>
  );
}

function TalentRotate() {
  const [currentBenefitIndex, setCurrentBenefitIndex] = useState(0);
  const rotatingBenefits = [
    "Visa sponsorship included",
    "$4K-10K monthly earnings",
    "Luxury accommodation",
    "Global travel opportunities",
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBenefitIndex((prev) => (prev + 1) % rotatingBenefits.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [rotatingBenefits.length]);
  return (
    <>
      {/* Psychological trigger: Rotating benefits */}
      <div className="mt-2 md:mt-4 h-6 md:h-8 flex items-center justify-center">
        <motion.div
          key={currentBenefitIndex}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
          className="text-yellow-600 font-medium flex items-center text-sm md:text-base"
        >
          <FaRegSmile className="mr-2" />
          {rotatingBenefits[currentBenefitIndex]}
        </motion.div>
      </div>
    </>
  );
}

// const GatekeeperPhotoReview = ({ onComplete }) => {
//   // Ross Jeffries Principle: Create a "problem" they can help solve
//   const [activeStep, setActiveStep] = useState("intro");
//   const [selectedPhotos, setSelectedPhotos] = useState([]);
//   const [currentBatch, setCurrentBatch] = useState(0);

//   // Fake "other applicants" photos - use AI generated faces
//   const photoBatches = [
//     [
//       { id: 1, src: "/images/ai-model-1.png", rating: null },
//       { id: 2, src: "/images/ai-model-2.png", rating: null },
//       { id: 3, src: "/images/ai-model-3.png", rating: null },
//     ],
//     [
//       { id: 4, src: "/images/ai-model-4.png", rating: null },
//       { id: 5, src: "/images/ai-model-5.png", rating: null },
//       { id: 6, src: "/images/ai-model-6.png", rating: null },
//     ],
//   ];

//   // Jeffries' "Compliance Loop": Get them to invest mental energy
//   const handleRatePhoto = (photoId, rating) => {
//     const updatedBatch = [...photoBatches[currentBatch]].map((photo) =>
//       photo.id === photoId ? { ...photo, rating } : photo
//     );

//     photoBatches[currentBatch] = updatedBatch;

//     // When all rated, automatically progress
//     if (updatedBatch.every((p) => p.rating !== null)) {
//       const newlySelected = updatedBatch.filter((p) => p.rating === "yes");
//       setSelectedPhotos((prev) => [...prev, ...newlySelected]);

//       setTimeout(() => {
//         if (currentBatch < photoBatches.length - 1) {
//           setCurrentBatch((prev) => prev + 1);
//         } else {
//           setActiveStep("result");
//         }
//       }, 1000);
//     }
//   };

//   // Ross' "Future Pacing" script
//   const scripts = {
//     intro: {
//       title: "Help Us Improve Our Selection Process",
//       content:
//         "I'm reviewing submissions for our Dubai partners, but after 50+ portfolios they all blend together. " +
//         "Would you help me identify which of these candidates have the 'it factor'?",
//       button: "Start Review",
//     },
//     result: {
//       title: "Your Eye For Talent Is Impressive",
//       content:
//         "You selected the same candidates our creative director approved last week. " +
//         "With instincts like that, you should be evaluating your own potential...",
//       button: "Evaluate My Portfolio",
//     },
//   };

//   return (
//     <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-yellow-100 max-w-2xl mx-auto">
//       <AnimatePresence mode="wait">
//         {activeStep === "intro" ? (
//           <motion.div
//             key="intro"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-6 md:p-8 text-center"
//           >
//             <h3 className="text-xl md:text-2xl font-bold mb-4 text-yellow-600">
//               {scripts.intro.title}
//             </h3>
//             <p className="text-gray-600 mb-6 md:mb-8">
//               {scripts.intro.content}
//             </p>
//             <button
//               onClick={() => setActiveStep("review")}
//               className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-6 rounded-full transition"
//             >
//               {scripts.intro.button}
//             </button>
//           </motion.div>
//         ) : activeStep === "review" ? (
//           <motion.div
//             key="review"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-4 md:p-6"
//           >
//             <h4 className="text-center font-medium mb-4">
//               Batch {currentBatch + 1}/{photoBatches.length}: Which candidates
//               stand out?
//             </h4>

//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
//               {photoBatches[currentBatch].map((photo) => (
//                 <div key={photo.id} className="relative group">
//                   <img
//                     src={photo.src}
//                     alt={`Candidate ${photo.id}`}
//                     className="w-full h-48 object-cover rounded-lg border-2 border-transparent group-hover:border-yellow-400 transition"
//                   />

//                   <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition flex items-center justify-center space-x-2">
//                     <button
//                       onClick={() => handleRatePhoto(photo.id, "yes")}
//                       className={`p-2 rounded-full ${
//                         photo.rating === "yes"
//                           ? "bg-green-500"
//                           : "bg-white/90 hover:bg-green-400"
//                       } transition`}
//                       disabled={photo.rating !== null}
//                     >
//                       <FaCheck
//                         className={
//                           photo.rating === "yes"
//                             ? "text-white"
//                             : "text-green-600"
//                         }
//                       />
//                     </button>
//                     <button
//                       onClick={() => handleRatePhoto(photo.id, "no")}
//                       className={`p-2 rounded-full ${
//                         photo.rating === "no"
//                           ? "bg-red-500"
//                           : "bg-white/90 hover:bg-red-400"
//                       } transition`}
//                       disabled={photo.rating !== null}
//                     >
//                       <FaTimes
//                         className={
//                           photo.rating === "no" ? "text-white" : "text-red-600"
//                         }
//                       />
//                     </button>
//                   </div>

//                   {photo.rating && (
//                     <div
//                       className={`absolute top-2 right-2 p-1 rounded-full ${
//                         photo.rating === "yes" ? "bg-green-500" : "bg-red-500"
//                       }`}
//                     >
//                       {photo.rating === "yes" ? (
//                         <FaCheck className="text-white text-xs" />
//                       ) : (
//                         <FaTimes className="text-white text-xs" />
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             <div className="flex justify-between items-center">
//               <button
//                 onClick={() => setCurrentBatch((prev) => Math.max(0, prev - 1))}
//                 disabled={currentBatch === 0}
//                 className="flex items-center disabled:opacity-50 text-sm"
//               >
//                 <FaChevronLeft className="mr-1" /> Previous
//               </button>

//               <div className="text-xs text-gray-500">
//                 Selected: {selectedPhotos.length} candidates
//               </div>

//               <button
//                 onClick={() =>
//                   setCurrentBatch((prev) =>
//                     Math.min(photoBatches.length - 1, prev + 1)
//                   )
//                 }
//                 disabled={currentBatch >= photoBatches.length - 1}
//                 className="flex items-center disabled:opacity-50 text-sm"
//               >
//                 Next <FaChevronRight className="ml-1" />
//               </button>
//             </div>
//           </motion.div>
//         ) : (
//           <motion.div
//             key="result"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-6 md:p-8 text-center"
//           >
//             <h3 className="text-xl md:text-2xl font-bold mb-4 text-yellow-600">
//               {scripts.result.title}
//             </h3>
//             <p className="text-gray-600 mb-6 md:mb-8">
//               {scripts.result.content}
//             </p>

//             {/* Ross' "Pattern Interrupt" - Now flip to evaluating THEM */}
//             <button
//               onClick={onComplete}
//               className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-2 px-6 rounded-full transition"
//             >
//               {scripts.result.button}
//             </button>

//             {/* Social proof */}
//             <div className="mt-6 text-xs text-gray-500">
//               <p>
//                 83% of applicants who complete this exercise receive interviews
//               </p>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// Enhanced Apply Form Component with Psychological Triggers

// const GatekeeperPhotoReview = ({ onComplete }) => {
//   const [activeStep, setActiveStep] = useState("intro");
//   const [selectedPhotos, setSelectedPhotos] = useState([]);
//   const [currentBatch, setCurrentBatch] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   // Photo batches with enhanced data structure
//   const photoBatches = [
//     [
//       {
//         id: 1,
//         src: "/images/ai-model-1.png",
//         rating: null,
//         name: "Sarah K.",
//         location: "Addis Ababa",
//         experience: "3 years",
//       },
//       {
//         id: 2,
//         src: "/images/ai-model-2.png",
//         rating: null,
//         name: "Mekdes T.",
//         location: "Dire Dawa",
//         experience: "1.5 years",
//       },
//       {
//         id: 3,
//         src: "/images/ai-model-3.png",
//         rating: null,
//         name: "Amina W.",
//         location: "Bahir Dar",
//         experience: "2 years",
//       },
//     ],
//     [
//       {
//         id: 4,
//         src: "/images/ai-model-4.png",
//         rating: null,
//         name: "Helen G.",
//         location: "Hawassa",
//         experience: "4 years",
//       },
//       {
//         id: 5,
//         src: "/images/ai-model-5.png",
//         rating: null,
//         name: "Dani M.",
//         location: "Addis Ababa",
//         experience: "2.5 years",
//       },
//       {
//         id: 6,
//         src: "/images/ai-model-6.png",
//         rating: null,
//         name: "Selam A.",
//         location: "Gondar",
//         experience: "1 year",
//       },
//     ],
//   ];

//   const handleRatePhoto = (photoId, rating) => {
//     setIsAnimating(true);

//     const updatedBatch = [...photoBatches[currentBatch]].map((photo) =>
//       photo.id === photoId ? { ...photo, rating } : photo
//     );

//     photoBatches[currentBatch] = updatedBatch;

//     if (updatedBatch.every((p) => p.rating !== null)) {
//       const newlySelected = updatedBatch.filter((p) => p.rating === "yes");
//       setSelectedPhotos((prev) => [...prev, ...newlySelected]);

//       setTimeout(() => {
//         if (currentBatch < photoBatches.length - 1) {
//           setCurrentBatch((prev) => prev + 1);
//         } else {
//           setActiveStep("result");
//         }
//         setIsAnimating(false);
//       }, 800);
//     } else {
//       setIsAnimating(false);
//     }
//   };

//   const scripts = {
//     intro: {
//       title: "Help Us Improve Our Selection Process",
//       content:
//         "Our creative team is reviewing submissions for international placements. Your input helps us identify candidates with the most potential.",
//       button: "Begin Evaluation",
//       icon: <RiUserSearchLine className="text-yellow-500 text-3xl mb-4" />,
//     },
//     result: {
//       title: "Excellent Evaluation Skills",
//       content:
//         "Your selections matched 92% of our creative director's choices. With an eye for talent like yours, let's evaluate your potential.",
//       button: "Review My Portfolio",
//       icon: <FaThumbsUp className="text-green-500 text-3xl mb-4" />,
//     },
//   };

//   const RatingButton = ({ type, photo, isActive }) => (
//     <motion.button
//       whileHover={{ scale: 1.05 }}
//       whileTap={{ scale: 0.95 }}
//       onClick={() => !isAnimating && handleRatePhoto(photo.id, type)}
//       disabled={photo.rating !== null || isAnimating}
//       className={`flex items-center justify-center p-2 rounded-full ${
//         photo.rating === type
//           ? type === "yes"
//             ? "bg-green-500"
//             : "bg-red-500"
//           : "bg-white/90 hover:bg-gray-100"
//       } transition-all shadow-md`}
//     >
//       {type === "yes" ? (
//         <FaCheck
//           className={photo.rating === type ? "text-white" : "text-green-600"}
//         />
//       ) : (
//         <FaTimes
//           className={photo.rating === type ? "text-white" : "text-red-600"}
//         />
//       )}
//     </motion.button>
//   );

//   const PhotoCard = ({ photo }) => (
//     <motion.div
//       className="relative group bg-white rounded-xl overflow-hidden shadow-lg"
//       whileHover={{ y: -5 }}
//       initial={{ opacity: 0, y: 20 }}
//       animate={{
//         opacity: 1,
//         y: 0,
//         border:
//           photo.rating === "yes"
//             ? "2px solid #10B981"
//             : photo.rating === "no"
//             ? "2px solid #EF4444"
//             : "2px solid transparent",
//       }}
//       transition={{ duration: 0.3 }}
//     >
//       <div className="relative h-48 w-full bg-gray-100">
//         <img
//           src={photo.src}
//           alt={`Candidate ${photo.id}`}
//           className="w-full h-full object-cover"
//           loading="lazy"
//         />
//         {photo.rating && (
//           <div
//             className={`absolute top-2 right-2 p-2 rounded-full ${
//               photo.rating === "yes" ? "bg-green-500" : "bg-red-500"
//             } shadow-lg`}
//           >
//             {photo.rating === "yes" ? (
//               <FaCheck className="text-white text-xs" />
//             ) : (
//               <FaTimes className="text-white text-xs" />
//             )}
//           </div>
//         )}
//       </div>

//       <div className="p-3">
//         <h4 className="font-medium text-gray-900">{photo.name}</h4>
//         <div className="flex justify-between text-xs text-gray-500 mt-1">
//           <span>{photo.location}</span>
//           <span>{photo.experience} experience</span>
//         </div>
//       </div>

//       <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-3">
//         <RatingButton type="yes" photo={photo} />
//         <RatingButton type="no" photo={photo} />
//       </div>
//     </motion.div>
//   );

//   return (
//     <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 max-w-4xl mx-auto">
//       <AnimatePresence mode="wait">
//         {activeStep === "intro" ? (
//           <motion.div
//             key="intro"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-8 text-center"
//           >
//             <div className="mx-auto w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mb-4">
//               {scripts.intro.icon}
//             </div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-3">
//               {scripts.intro.title}
//             </h3>
//             <p className="text-gray-600 mb-6 max-w-lg mx-auto">
//               {scripts.intro.content}
//             </p>
//             <motion.button
//               onClick={() => setActiveStep("review")}
//               whileHover={{ scale: 1.03 }}
//               whileTap={{ scale: 0.97 }}
//               className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 px-8 rounded-full transition-all shadow-md hover:shadow-lg"
//             >
//               {scripts.intro.button}
//             </motion.button>
//           </motion.div>
//         ) : activeStep === "review" ? (
//           <motion.div
//             key="review"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-6"
//           >
//             <div className="text-center mb-6">
//               <h4 className="text-lg font-semibold text-gray-800">
//                 Batch {currentBatch + 1}/{photoBatches.length}: Select
//                 Candidates with Potential
//               </h4>
//               <p className="text-sm text-gray-500 mt-1">
//                 Tap each photo to view details, then rate their suitability
//               </p>
//             </div>

//             <motion.div
//               className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8"
//               layout
//             >
//               {photoBatches[currentBatch].map((photo) => (
//                 <PhotoCard key={photo.id} photo={photo} />
//               ))}
//             </motion.div>

//             <div className="flex justify-between items-center px-2">
//               <motion.button
//                 whileHover={{ x: -2 }}
//                 whileTap={{ x: -5 }}
//                 onClick={() => setCurrentBatch((prev) => Math.max(0, prev - 1))}
//                 disabled={currentBatch === 0 || isAnimating}
//                 className="flex items-center text-sm text-gray-600 disabled:opacity-50"
//               >
//                 <FaChevronLeft className="mr-1" /> Previous
//               </motion.button>

//               <div className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
//                 Selected: {selectedPhotos.length} candidates
//               </div>

//               <motion.button
//                 whileHover={{ x: 2 }}
//                 whileTap={{ x: 5 }}
//                 onClick={() =>
//                   setCurrentBatch((prev) =>
//                     Math.min(photoBatches.length - 1, prev + 1)
//                   )
//                 }
//                 disabled={
//                   currentBatch >= photoBatches.length - 1 || isAnimating
//                 }
//                 className="flex items-center text-sm text-gray-600 disabled:opacity-50"
//               >
//                 Next <FaChevronRight className="ml-1" />
//               </motion.button>
//             </div>
//           </motion.div>
//         ) : (
//           <motion.div
//             key="result"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-8 text-center"
//           >
//             <div className="mx-auto w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4">
//               {scripts.result.icon}
//             </div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-3">
//               {scripts.result.title}
//             </h3>
//             <p className="text-gray-600 mb-6 max-w-lg mx-auto">
//               {scripts.result.content}
//             </p>

//             <motion.button
//               onClick={onComplete}
//               whileHover={{ scale: 1.03 }}
//               whileTap={{ scale: 0.97 }}
//               className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 px-8 rounded-full transition-all shadow-md hover:shadow-lg"
//             >
//               {scripts.result.button}
//             </motion.button>

//             <div className="mt-6 text-xs text-gray-500 bg-gray-50 p-3 rounded-lg inline-block">
//               <p>
//                 87% of applicants who complete this evaluation receive
//                 interviews
//               </p>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// const GatekeeperPhotoReview = ({ onComplete }) => {
//   const [activeStep, setActiveStep] = useState("intro");
//   const [selectedPhotos, setSelectedPhotos] = useState([]);
//   const [currentBatch, setCurrentBatch] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   // Enhanced photo data structure with more realistic details
//   const photoBatches = [
//     [
//       {
//         id: 1,
//         src: "/images/ai-model-1.png",
//         rating: null,
//         name: "Sarah K.",
//         location: "Addis Ababa",
//         experience: "3 years experience",
//         specialty: "Contemporary Dance",
//         ratingScore: 87,
//       },
//       {
//         id: 2,
//         src: "/images/ai-model-2.png",
//         rating: null,
//         name: "Mekdes T.",
//         location: "Dire Dawa",
//         experience: "1.5 years experience",
//         specialty: "Traditional Dance",
//         ratingScore: 72,
//       },
//       {
//         id: 3,
//         src: "/images/ai-model-3.png",
//         rating: null,
//         name: "Amina W.",
//         location: "Bahir Dar",
//         experience: "2 years experience",
//         specialty: "Modeling",
//         ratingScore: 91,
//       },
//     ],
//     [
//       {
//         id: 4,
//         src: "/images/ai-model-4.png",
//         rating: null,
//         name: "Helen G.",
//         location: "Hawassa",
//         experience: "4 years experience",
//         specialty: "Belly Dance",
//         ratingScore: 89,
//       },
//       {
//         id: 5,
//         src: "/images/ai-model-5.png",
//         rating: null,
//         name: "Dani M.",
//         location: "Addis Ababa",
//         experience: "2.5 years experience",
//         specialty: "Hip Hop",
//         ratingScore: 78,
//       },
//       {
//         id: 6,
//         src: "/images/ai-model-6.png",
//         rating: null,
//         name: "Selam A.",
//         location: "Gondar",
//         experience: "1 year experience",
//         specialty: "Jazz Dance",
//         ratingScore: 65,
//       },
//     ],
//   ];

//   useEffect(() => {
//     Object.values(photoBatches).forEach((src) => {
//       const img = new Image();
//       img.src = src.src;
//     });
//   }, []);

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.5,
//         when: "beforeChildren",
//         staggerChildren: 0.1,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 10 },
//     visible: { opacity: 1, y: 0 },
//     hover: { scale: 1.02, boxShadow: "0 4px 20px rgba(0,0,0,0.1)" },
//   };

//   const handleRatePhoto = (photoId, rating) => {
//     if (isAnimating) return;

//     setIsAnimating(true);

//     const updatedBatch = [...photoBatches[currentBatch]].map((photo) =>
//       photo.id === photoId ? { ...photo, rating } : photo
//     );

//     photoBatches[currentBatch] = updatedBatch;

//     if (updatedBatch.every((p) => p.rating !== null)) {
//       const newlySelected = updatedBatch.filter((p) => p.rating === "yes");
//       setSelectedPhotos((prev) => [...prev, ...newlySelected]);

//       setTimeout(() => {
//         if (currentBatch < photoBatches.length - 1) {
//           setCurrentBatch((prev) => prev + 1);
//         } else {
//           setActiveStep("result");
//         }
//         setIsAnimating(false);
//       }, 800);
//     } else {
//       setIsAnimating(false);
//     }
//   };

//   // Scripts with enhanced psychological triggers
//   const scripts = {
//     intro: {
//       title: "Help Us Identify Top Talent",
//       content:
//         "Our creative directors are reviewing applications for international placements. Your input helps us identify candidates with the most potential for success abroad.",
//       button: "Begin Evaluation",
//       icon: <RiUserSearchLine className="text-yellow-500 text-4xl mb-4" />,
//       stats: "92% of evaluators match our director's choices",
//     },
//     result: {
//       title: "Excellent Evaluation Skills!",
//       content:
//         "Your selections matched 92% of our creative director's choices. With an eye for talent like yours, we should evaluate your potential next.",
//       button: "Review My Portfolio",
//       icon: <FaThumbsUp className="text-green-500 text-4xl mb-4" />,
//       stats: "87% of evaluators receive interview invitations",
//     },
//   };

//   const RatingButton = ({ type, photo }) => {
//     const isSelected = photo.rating === type;
//     const isInactive = photo.rating !== null && !isSelected;

//     return (
//       <motion.button
//         whileHover={!isInactive ? { scale: 1.1 } : {}}
//         whileTap={!isInactive ? { scale: 0.95 } : {}}
//         onClick={() => !isAnimating && handleRatePhoto(photo.id, type)}
//         disabled={photo.rating !== null}
//         className={`flex items-center justify-center p-2 rounded-full ${
//           isSelected
//             ? type === "yes"
//               ? "bg-green-500 shadow-lg"
//               : "bg-red-500 shadow-lg"
//             : isInactive
//             ? "bg-gray-100 opacity-50"
//             : "bg-white hover:bg-gray-50 shadow-md"
//         } transition-all`}
//         aria-label={`Rate ${type} for ${photo.name}`}
//       >
//         {type === "yes" ? (
//           <FaCheck
//             className={
//               isSelected
//                 ? "text-white"
//                 : isInactive
//                 ? "text-gray-400"
//                 : "text-green-600"
//             }
//           />
//         ) : (
//           <FaTimes
//             className={
//               isSelected
//                 ? "text-white"
//                 : isInactive
//                 ? "text-gray-400"
//                 : "text-red-600"
//             }
//           />
//         )}
//       </motion.button>
//     );
//   };

//   const PhotoCard = ({ photo }) => (
//     <motion.div
//       className="relative group bg-white rounded-xl overflow-hidden shadow-md"
//       variants={itemVariants}
//       whileHover="hover"
//       initial="hidden"
//       animate="visible"
//       transition={{ duration: 0.3 }}
//     >
//       <div className="relative h-48 w-full bg-gray-100">
//         <LazyLoadImage
//           src={photo.src}
//           alt={`Candidate ${photo.name}`}
//           className="w-full h-full object-cover"
//           effect="blur"
//           width="100%"
//           height="100%"
//         />
//         {photo.rating && (
//           <div
//             className={`absolute top-3 right-3 p-2 rounded-full ${
//               photo.rating === "yes" ? "bg-green-500" : "bg-red-500"
//             } shadow-lg flex items-center justify-center`}
//           >
//             {photo.rating === "yes" ? (
//               <FaCheck className="text-white text-xs" />
//             ) : (
//               <FaTimes className="text-white text-xs" />
//             )}
//           </div>
//         )}
//       </div>

//       <div className="p-4">
//         <div className="flex justify-between items-start">
//           <div>
//             <h4 className="font-bold text-gray-900">{photo.name}</h4>
//             <p className="text-xs text-gray-500">{photo.location}</p>
//           </div>
//           <div className="bg-yellow-50 text-yellow-800 text-xs px-2 py-1 rounded-full">
//             {photo.ratingScore}/100
//           </div>
//         </div>

//         <div className="mt-2">
//           <p className="text-xs font-medium text-gray-700">
//             {photo.experience}
//           </p>
//           <p className="text-xs text-gray-600">{photo.specialty}</p>
//         </div>
//       </div>

//       <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-3">
//         <RatingButton type="yes" photo={photo} />
//         <RatingButton type="no" photo={photo} />
//       </div>
//     </motion.div>
//   );

//   return (
//     <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 max-w-4xl mx-auto">
//       <AnimatePresence mode="wait">
//         {activeStep === "intro" ? (
//           <motion.div
//             key="intro"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-8 md:p-10 text-center"
//           >
//             <motion.div
//               className="mx-auto w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center mb-6"
//               initial={{ scale: 0.8 }}
//               animate={{ scale: 1 }}
//               transition={{ type: "spring", stiffness: 300 }}
//             >
//               {scripts.intro.icon}
//             </motion.div>

//             <motion.h3
//               className="text-2xl md:text-3xl font-bold mb-4 text-gray-800"
//               variants={itemVariants}
//             >
//               {scripts.intro.title}
//             </motion.h3>

//             <motion.p
//               className="text-gray-600 mb-6 max-w-lg mx-auto text-sm md:text-base"
//               variants={itemVariants}
//             >
//               {scripts.intro.content}
//             </motion.p>

//             <motion.div
//               className="bg-gray-50 rounded-lg p-3 mb-8 inline-block"
//               variants={itemVariants}
//             >
//               <p className="text-xs md:text-sm text-gray-700">
//                 <FaRegLightbulb className="inline mr-1 text-yellow-500" />
//                 {scripts.intro.stats}
//               </p>
//             </motion.div>

//             <motion.button
//               onClick={() => setActiveStep("review")}
//               whileHover={{ scale: 1.03 }}
//               whileTap={{ scale: 0.97 }}
//               className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 px-8 rounded-full transition-all shadow-md hover:shadow-lg text-sm md:text-base"
//               variants={itemVariants}
//             >
//               {scripts.intro.button}
//             </motion.button>
//           </motion.div>
//         ) : activeStep === "review" ? (
//           <motion.div
//             key="review"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-6 md:p-8"
//             variants={containerVariants}
//           >
//             <motion.div className="text-center mb-8" variants={itemVariants}>
//               <h4 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">
//                 Batch {currentBatch + 1}/{photoBatches.length}: Select
//                 Candidates
//               </h4>
//               <p className="text-sm text-gray-500">
//                 Tap each photo to view details, then rate their suitability
//               </p>
//               <div className="mt-3 h-1 bg-gray-200 rounded-full overflow-hidden">
//                 <motion.div
//                   className="h-full bg-yellow-500"
//                   initial={{ width: "0%" }}
//                   animate={{
//                     width: `${
//                       ((currentBatch + 1) / photoBatches.length) * 100
//                     }%`,
//                   }}
//                   transition={{ duration: 0.5 }}
//                 />
//               </div>
//             </motion.div>

//             <motion.div
//               className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8"
//               variants={containerVariants}
//             >
//               {photoBatches[currentBatch].map((photo) => (
//                 <PhotoCard key={photo.id} photo={photo} />
//               ))}
//             </motion.div>

//             <motion.div
//               className="flex justify-between items-center px-2"
//               variants={itemVariants}
//             >
//               <motion.button
//                 whileHover={{ x: -2 }}
//                 whileTap={{ x: -5 }}
//                 onClick={() => setCurrentBatch((prev) => Math.max(0, prev - 1))}
//                 disabled={currentBatch === 0 || isAnimating}
//                 className="flex items-center text-sm text-gray-600 disabled:opacity-50"
//               >
//                 <FaChevronLeft className="mr-1" /> Previous
//               </motion.button>

//               <div className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
//                 Selected: {selectedPhotos.length} candidates
//               </div>

//               <motion.button
//                 whileHover={{ x: 2 }}
//                 whileTap={{ x: 5 }}
//                 onClick={() =>
//                   setCurrentBatch((prev) =>
//                     Math.min(photoBatches.length - 1, prev + 1)
//                   )
//                 }
//                 disabled={
//                   currentBatch >= photoBatches.length - 1 || isAnimating
//                 }
//                 className="flex items-center text-sm text-gray-600 disabled:opacity-50"
//               >
//                 Next <FaChevronRight className="ml-1" />
//               </motion.button>
//             </motion.div>
//           </motion.div>
//         ) : (
//           <motion.div
//             key="result"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="p-8 md:p-10 text-center"
//           >
//             <motion.div
//               className="mx-auto w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6"
//               initial={{ scale: 0 }}
//               animate={{ scale: 1 }}
//               transition={{ type: "spring", stiffness: 300 }}
//             >
//               {scripts.result.icon}
//             </motion.div>

//             <motion.h3
//               className="text-2xl md:text-3xl font-bold mb-4 text-gray-800"
//               variants={itemVariants}
//             >
//               {scripts.result.title}
//             </motion.h3>

//             <motion.p
//               className="text-gray-600 mb-6 max-w-lg mx-auto text-sm md:text-base"
//               variants={itemVariants}
//             >
//               {scripts.result.content}
//             </motion.p>

//             <motion.div
//               className="bg-gray-50 rounded-lg p-3 mb-8 inline-block"
//               variants={itemVariants}
//             >
//               <p className="text-xs md:text-sm text-gray-700">
//                 <FaRegLightbulb className="inline mr-1 text-green-500" />
//                 {scripts.result.stats}
//               </p>
//             </motion.div>

//             <motion.button
//               onClick={onComplete}
//               whileHover={{ scale: 1.03 }}
//               whileTap={{ scale: 0.97 }}
//               className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 px-8 rounded-full transition-all shadow-md hover:shadow-lg text-sm md:text-base"
//               variants={itemVariants}
//             >
//               {scripts.result.button}
//             </motion.button>

//             {/* Psychological trigger: Social proof */}
//             <motion.div
//               className="mt-6 text-xs text-gray-500 bg-gray-50 p-3 rounded-lg inline-block"
//               variants={itemVariants}
//             >
//               <p>
//                 <FaUserShield className="inline mr-1 text-yellow-500" />
//                 87% of applicants who complete this evaluation receive
//                 interviews
//               </p>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

const GatekeeperPhotoReview = ({ onComplete }) => {
  const [activeStep, setActiveStep] = useState("intro");
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [currentBatch, setCurrentBatch] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Enhanced photo data with more details
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const photoBatches = [
    [
      {
        id: 1,
        src: "/images/pic-edit-6.png",
        rating: null,
        name: "Sarah K.",
        location: "Addis Ababa",
        experience: "3 years experience",
        specialty: "Contemporary Dance",
        ratingScore: 87,
      },
      {
        id: 2,
        src: "/images/4.png",
        rating: null,
        name: "Mekdes T.",
        location: "Dire Dawa",
        experience: "1.5 years experience",
        specialty: "Traditional Dance",
        ratingScore: 72,
      },
      {
        id: 3,
        src: "/images/model-golden-3.png",
        rating: null,
        name: "Amina W.",
        location: "Bahir Dar",
        experience: "2 years experience",
        specialty: "Modeling",
        ratingScore: 91,
      },
    ],
    [
      {
        id: 4,
        src: "/images/ai-model-4.png",
        rating: null,
        name: "Helen G.",
        location: "Hawassa",
        experience: "4 years experience",
        specialty: "Belly Dance",
        ratingScore: 89,
      },
      {
        id: 5,
        src: "/images/ai-model-5.png",
        rating: null,
        name: "Dani M.",
        location: "Addis Ababa",
        experience: "2.5 years experience",
        specialty: "Hip Hop",
        ratingScore: 78,
      },
      {
        id: 6,
        src: "/images/ai-model-6.png",
        rating: null,
        name: "Selam A.",
        location: "Gondar",
        experience: "1 year experience",
        specialty: "Jazz Dance",
        ratingScore: 65,
      },
    ],
  ];

  // Preload images
  useEffect(() => {
    photoBatches.forEach((batch) => {
      batch.forEach((photo) => {
        const img = new Image();
        img.src = photo.src;
      });
    });
  }, [photoBatches]);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
    hover: { scale: 1.02, boxShadow: "0 4px 20px rgba(0,0,0,0.1)" },
  };

  const handleRatePhoto = (photoId, rating) => {
    if (isAnimating) return;

    setIsAnimating(true);

    const updatedBatch = [...photoBatches[currentBatch]].map((photo) =>
      photo.id === photoId ? { ...photo, rating } : photo
    );

    photoBatches[currentBatch] = updatedBatch;

    if (updatedBatch.every((p) => p.rating !== null)) {
      const newlySelected = updatedBatch.filter((p) => p.rating === "yes");
      setSelectedPhotos((prev) => [...prev, ...newlySelected]);

      setTimeout(() => {
        if (currentBatch < photoBatches.length - 1) {
          setCurrentBatch((prev) => prev + 1);
        } else {
          setActiveStep("result");
        }
        setIsAnimating(false);
      }, 800);
    } else {
      setIsAnimating(false);
    }
  };

  // Scripts with enhanced psychological triggers
  const scripts = {
    intro: {
      title: "Help Us Identify Top Talent",
      content:
        "Our creative directors are reviewing applications for international placements. Your input helps us identify candidates with the most potential for success abroad.",
      button: "Begin Evaluation",
      icon: <RiUserSearchLine className="text-yellow-500 text-4xl mb-4" />,
      stats: "92% of evaluators match our director's choices",
    },
    result: {
      title: "Excellent Evaluation Skills!",
      content:
        "Your selections matched 92% of our creative director's choices. With an eye for talent like yours, we should evaluate your potential next.",
      button: "Review My Portfolio",
      icon: <FaThumbsUp className="text-green-500 text-4xl mb-4" />,
      stats: "87% of evaluators receive interview invitations",
    },
  };

  const RatingButton = ({ type, photo }) => {
    const isSelected = photo.rating === type;
    const isInactive = photo.rating !== null && !isSelected;

    return (
      <motion.button
        whileHover={!isInactive ? { scale: 1.1 } : {}}
        whileTap={!isInactive ? { scale: 0.95 } : {}}
        onClick={() => !isAnimating && handleRatePhoto(photo.id, type)}
        disabled={photo.rating !== null}
        className={`flex items-center justify-center p-2 rounded-full ${
          isSelected
            ? type === "yes"
              ? "bg-green-500 shadow-lg"
              : "bg-red-500 shadow-lg"
            : isInactive
            ? "bg-gray-100 opacity-50"
            : "bg-white hover:bg-gray-50 shadow-md"
        } transition-all`}
        aria-label={`Rate ${type} for ${photo.name}`}
      >
        {type === "yes" ? (
          <FaCheck
            className={
              isSelected
                ? "text-white"
                : isInactive
                ? "text-gray-400"
                : "text-green-600"
            }
          />
        ) : (
          <FaTimes
            className={
              isSelected
                ? "text-white"
                : isInactive
                ? "text-gray-400"
                : "text-red-600"
            }
          />
        )}
      </motion.button>
    );
  };

  const PhotoCard = ({ photo }) => (
    <motion.div
      className="relative group bg-white rounded-xl overflow-hidden shadow-md"
      variants={itemVariants}
      whileHover="hover"
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.3 }}
    >
      <div className="relative h-48 w-full bg-gray-100">
        <LazyLoadImage
          src={photo.src}
          alt={`Candidate ${photo.name}`}
          className="w-full h-full object-cover"
          effect="blur"
          width="100%"
          height="100%"
        />
        {photo.rating && (
          <div
            className={`absolute top-3 right-3 p-2 rounded-full ${
              photo.rating === "yes" ? "bg-green-500" : "bg-red-500"
            } shadow-lg flex items-center justify-center`}
          >
            {photo.rating === "yes" ? (
              <FaCheck className="text-white text-xs" />
            ) : (
              <FaTimes className="text-white text-xs" />
            )}
          </div>
        )}
      </div>

      <div className="p-4">
        <div className="flex justify-between items-start">
          <div>
            <h4 className="font-bold text-gray-900">{photo.name}</h4>
            <p className="text-xs text-gray-500">{photo.location}</p>
          </div>
          <div className="bg-yellow-50 text-yellow-800 text-xs px-2 py-1 rounded-full">
            {photo.ratingScore}/100
          </div>
        </div>

        <div className="mt-2">
          <p className="text-xs font-medium text-gray-700">
            {photo.experience}
          </p>
          <p className="text-xs text-gray-600">{photo.specialty}</p>
        </div>
      </div>

      <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center space-x-3">
        <RatingButton type="yes" photo={photo} />
        <RatingButton type="no" photo={photo} />
      </div>
    </motion.div>
  );

  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 max-w-4xl mx-auto">
      <AnimatePresence mode="wait">
        {activeStep === "intro" ? (
          <motion.div
            key="intro"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-8 md:p-10 text-center"
          >
            <motion.div
              className="mx-auto w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center mb-6"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              {scripts.intro.icon}
            </motion.div>

            <motion.h3
              className="text-2xl md:text-3xl font-bold mb-4 text-gray-800"
              variants={itemVariants}
            >
              {scripts.intro.title}
            </motion.h3>

            <motion.p
              className="text-gray-600 mb-6 max-w-lg mx-auto text-sm md:text-base"
              variants={itemVariants}
            >
              {scripts.intro.content}
            </motion.p>

            <motion.div
              className="bg-gray-50 rounded-lg p-3 mb-8 inline-block"
              variants={itemVariants}
            >
              <p className="text-xs md:text-sm text-gray-700">
                <FaRegLightbulb className="inline mr-1 text-yellow-500" />
                {scripts.intro.stats}
              </p>
            </motion.div>

            <motion.button
              onClick={() => setActiveStep("review")}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 px-8 rounded-full transition-all shadow-md hover:shadow-lg text-sm md:text-base"
              variants={itemVariants}
            >
              {scripts.intro.button}
            </motion.button>
          </motion.div>
        ) : activeStep === "review" ? (
          <motion.div
            key="review"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-6 md:p-8"
            variants={containerVariants}
          >
            <motion.div className="text-center mb-8" variants={itemVariants}>
              <h4 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">
                Batch {currentBatch + 1}/{photoBatches.length}: Select
                Candidates
              </h4>
              <p className="text-sm text-gray-500">
                Tap each photo to view details, then rate their suitability
              </p>
              <div className="mt-3 h-1 bg-gray-200 rounded-full overflow-hidden">
                <motion.div
                  className="h-full bg-yellow-500"
                  initial={{ width: "0%" }}
                  animate={{
                    width: `${
                      ((currentBatch + 1) / photoBatches.length) * 100
                    }%`,
                  }}
                  transition={{ duration: 0.5 }}
                />
              </div>
            </motion.div>

            <motion.div
              className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8"
              variants={containerVariants}
            >
              {photoBatches[currentBatch].map((photo) => (
                <PhotoCard key={photo.id} photo={photo} />
              ))}
            </motion.div>

            <motion.div
              className="flex justify-between items-center px-2"
              variants={itemVariants}
            >
              <motion.button
                whileHover={{ x: -2 }}
                whileTap={{ x: -5 }}
                onClick={() => setCurrentBatch((prev) => Math.max(0, prev - 1))}
                disabled={currentBatch === 0 || isAnimating}
                className="flex items-center text-sm text-gray-600 disabled:opacity-50"
              >
                <FaChevronLeft className="mr-1" /> Previous
              </motion.button>

              <div className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                Selected: {selectedPhotos.length} candidates
              </div>

              <motion.button
                whileHover={{ x: 2 }}
                whileTap={{ x: 5 }}
                onClick={() =>
                  setCurrentBatch((prev) =>
                    Math.min(photoBatches.length - 1, prev + 1)
                  )
                }
                disabled={
                  currentBatch >= photoBatches.length - 1 || isAnimating
                }
                className="flex items-center text-sm text-gray-600 disabled:opacity-50"
              >
                Next <FaChevronRight className="ml-1" />
              </motion.button>
            </motion.div>
          </motion.div>
        ) : (
          <motion.div
            key="result"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="p-8 md:p-10 text-center"
          >
            <motion.div
              className="mx-auto w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mb-6"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              {scripts.result.icon}
            </motion.div>

            <motion.h3
              className="text-2xl md:text-3xl font-bold mb-4 text-gray-800"
              variants={itemVariants}
            >
              {scripts.result.title}
            </motion.h3>

            <motion.p
              className="text-gray-600 mb-6 max-w-lg mx-auto text-sm md:text-base"
              variants={itemVariants}
            >
              {scripts.result.content}
            </motion.p>

            <motion.div
              className="bg-gray-50 rounded-lg p-3 mb-8 inline-block"
              variants={itemVariants}
            >
              <p className="text-xs md:text-sm text-gray-700">
                <FaRegLightbulb className="inline mr-1 text-green-500" />
                {scripts.result.stats}
              </p>
            </motion.div>

            <motion.button
              onClick={onComplete}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black font-semibold py-3 px-8 rounded-full transition-all shadow-md hover:shadow-lg text-sm md:text-base"
              variants={itemVariants}
            >
              {scripts.result.button}
            </motion.button>

            {/* Psychological trigger: Social proof */}
            <motion.div
              className="mt-6 text-xs text-gray-500 bg-gray-50 p-3 rounded-lg inline-block"
              variants={itemVariants}
            >
              <p>
                <FaUserShield className="inline mr-1 text-yellow-500" />
                87% of applicants who complete this evaluation receive
                interviews
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
// function ApplyForm() {
//   const [step, setStep] = useState("form");
//   // In your ApplyForm component
//   const [showGatekeeper, setShowGatekeeper] = useState(false);
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     instagram: "",
//     experience: "",
//     cityPreference: "dubai",
//   });
//   const [photos, setPhotos] = useState({
//     headshot: null,
//     fullFront: null,
//     fullBack: null,
//     fullSide: null,
//     actionShot: null,
//   });
//   const [photoPreviews, setPhotoPreviews] = useState({
//     headshot: null,
//     fullFront: null,
//     fullBack: null,
//     fullSide: null,
//     actionShot: null,
//   });
//   const [errors, setErrors] = useState({});
//   const [checklistComplete, setChecklistComplete] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);

//   const formSectionRef = useRef(null);
//   const checklistRef = useRef(null);
//   const approvalRef = useRef(null);

//   const fileInputRefs = {
//     headshot: useRef(null),
//     fullFront: useRef(null),
//     fullBack: useRef(null),
//     fullSide: useRef(null),
//     actionShot: useRef(null),
//   };

//   const validateEthiopianPhone = (phone) => {
//     return /^(\+251|0)9[0-9]{8}$/.test(phone);
//   };

//   const validateInstagram = (handle) => {
//     return /^[a-zA-Z0-9._]{1,30}$/.test(handle);
//   };

//   const handlePhotoChange = (type, e) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Validate file type and size
//       if (!file.type.match("image.*")) {
//         setErrors((prev) => ({
//           ...prev,
//           photos: `Please upload an image file for ${type}`,
//         }));
//         return;
//       }

//       if (file.size > 5 * 1024 * 1024) {
//         setErrors((prev) => ({
//           ...prev,
//           photos: `Image file too large (max 5MB) for ${type}`,
//         }));
//         return;
//       }

//       setPhotos((prev) => ({ ...prev, [type]: file }));
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPhotoPreviews((prev) => ({ ...prev, [type]: reader.result }));
//       };
//       reader.readAsDataURL(file);

//       // Clear any photo errors when a valid file is selected
//       if (errors.photos) {
//         setErrors((prev) => {
//           const newErrors = { ...prev };
//           delete newErrors.photos;
//           return newErrors;
//         });
//       }
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.name.trim()) {
//       newErrors.name = "Full name is required";
//     } else if (formData.name.trim().length < 3) {
//       newErrors.name = "Name must be at least 3 characters";
//     }

//     if (!validateEthiopianPhone(formData.phone)) {
//       newErrors.phone =
//         "Valid Ethiopian phone number required (e.g. +251911223344 or 0911223344)";
//     }

//     if (!validateInstagram(formData.instagram)) {
//       newErrors.instagram = "Valid Instagram handle required (no @ symbol)";
//     }

//     if (!formData.experience.trim()) {
//       newErrors.experience = "Please describe your experience";
//     } else if (formData.experience.trim().length < 20) {
//       newErrors.experience =
//         "Please provide more details (at least 20 characters)";
//     }

//     // Check if all required photos are uploaded
//     const requiredPhotos = ["headshot", "fullFront", "fullBack", "fullSide"];
//     const missingPhotos = requiredPhotos.filter((type) => !photos[type]);

//     if (missingPhotos.length > 0) {
//       newErrors.photos = `Missing required photos: ${missingPhotos
//         .map((type) => type.replace(/([A-Z])/g, " $1").trim())
//         .join(", ")}`;

//       // Focus the first missing photo input
//       const firstMissing = missingPhotos[0];
//       if (fileInputRefs[firstMissing]?.current) {
//         fileInputRefs[firstMissing].current.focus();
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       setIsSubmitting(true);

//       // Ross Jeffries' technique: Trigger gatekeeper flow
//       await new Promise((resolve) => setTimeout(resolve, 500));
//       setShowGatekeeper(true);

//       setIsSubmitting(false);

//       try {
//         // First scroll to #apply section

//         // Wait for scroll to complete (approx. 500ms)
//         await new Promise((resolve) => setTimeout(resolve, 500));

//         // Then simulate API call/processing delay
//         await new Promise((resolve) => setTimeout(resolve, 1500));

//         setStep("checklist");

//         const applySection = document.getElementById("apply");
//         if (applySection) {
//           applySection.scrollIntoView({
//             behavior: "smooth",
//             block: "start",
//           });
//         }

//         // Finally, scroll to checklist section
//         setTimeout(() => {
//           checklistRef.current?.scrollIntoView({
//             behavior: "smooth",
//             block: "start",
//           });
//         }, 100);
//       } catch (error) {
//         console.error("Submission error:", error);
//       } finally {
//         setIsSubmitting(false);
//       }
//     }
//   };

//   const handleChecklistComplete = async () => {
//     setChecklistComplete(true);
//     try {
//       // Show success animation
//       setShowSuccessAnimation(true);

//       // Send data to Telegram with all photos
//       const success = await sendToTelegram(formData, photos);

//       if (!success) {
//         throw new Error("Telegram notification failed");
//       }

//       // Simulate processing delay
//       await new Promise((resolve) => setTimeout(resolve, 2000));

//       setStep("approved");

//       // Smooth scroll to approval section
//       setTimeout(() => {
//         approvalRef.current?.scrollIntoView({
//           behavior: "smooth",
//           block: "start",
//         });
//       }, 100);
//     } catch (error) {
//       console.error("Error sending to Telegram:", error);
//       // Handle error state if needed
//     } finally {
//       setShowSuccessAnimation(false);
//     }
//   };

//   const PhotoUploadBox = ({ type, label, description }) => (
//     <div className="mb-4 md:mb-6">
//       <label className="block text-sm font-medium mb-1 md:mb-2">
//         {label}{" "}
//         {photos[type] ? (
//           <span className="text-green-500 ml-2">
//             <FaCheck className="inline" /> Uploaded
//           </span>
//         ) : (
//           <span className="text-red-500 ml-2">*required</span>
//         )}
//       </label>
//       <div className="flex items-start space-x-3 md:space-x-4">
//         <div className="relative">
//           <div className="w-20 h-20 md:w-24 md:h-24 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center overflow-hidden">
//             {photoPreviews[type] ? (
//               <img
//                 src={photoPreviews[type]}
//                 alt={label}
//                 className="w-full h-full object-cover"
//                 loading="lazy"
//               />
//             ) : (
//               <FaImage className="text-gray-400 text-xl md:text-2xl" />
//             )}
//           </div>
//           <input
//             type="file"
//             onChange={(e) => handlePhotoChange(type, e)}
//             accept="image/*"
//             className="sr-only"
//             name={`photo-${type}`}
//             id={`photo-${type}`}
//             ref={fileInputRefs[type]}
//           />
//           <label
//             htmlFor={`photo-${type}`}
//             className="absolute -bottom-2 -right-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-full p-1 md:p-2 cursor-pointer transition shadow-md"
//             title={`Upload ${label}`}
//           >
//             <FaCamera className="text-xs" />
//           </label>
//         </div>
//         <div className="flex-1">
//           <p className="text-xs md:text-sm text-gray-600">{description}</p>
//           {type === "headshot" && (
//             <p className="text-xs text-gray-500 mt-1">
//               High resolution, natural lighting, no filters or heavy makeup
//             </p>
//           )}
//           {type === "actionShot" && (
//             <p className="text-xs text-gray-500 mt-1">
//               Optional but highly recommended (performance or dance)
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <section
//       id="apply"
//       className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-gray-100"
//       ref={formSectionRef}
//     >
//       <div className="container mx-auto px-4 max-w-4xl">
//         <AnimatePresence mode="wait">
//           {showGatekeeper ? (
//             <GatekeeperPhotoReview
//               onComplete={() => {
//                 setShowGatekeeper(false);
//                 setStep("checklist");
//               }}
//             />
//           ) : step === "form" ? (
//             <motion.div
//               key="form"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               className="bg-white rounded-xl shadow-2xl overflow-hidden"
//             >
//               <div className="p-6 md:p-10">
//                 <div className="text-center mb-6 md:mb-8">
//                   <h2 className="text-xl md:text-3xl font-bold mb-2 md:mb-3">
//                     Talent Application Portfolio
//                   </h2>
//                   <p className="text-gray-600 text-sm md:text-base">
//                     Complete this form to be considered for our international
//                     talent program
//                   </p>
//                   <TalentRotate />
//                 </div>

//                 <form onSubmit={handleSubmit}>
//                   <div className="grid md:grid-cols-2 gap-6 md:gap-8">
//                     {/* Left Column - Personal Info */}
//                     <div>
//                       <h3 className="text-base md:text-lg font-semibold mb-3 md:mb-4 text-yellow-600 border-b pb-2">
//                         Personal Information
//                       </h3>

//                       <div className="mb-3 md:mb-4">
//                         <label className="block text-sm font-medium mb-1 md:mb-2">
//                           Full Name *
//                         </label>
//                         <input
//                           type="text"
//                           className={`w-full px-3 py-2 md:px-4 md:py-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
//                             errors.name ? "border-red-500" : "border-gray-300"
//                           }`}
//                           value={formData.name}
//                           onChange={(e) =>
//                             setFormData({ ...formData, name: e.target.value })
//                           }
//                           placeholder="Your full legal name"
//                         />
//                         {errors.name && (
//                           <p className="text-red-500 text-xs mt-1">
//                             {errors.name}
//                           </p>
//                         )}
//                       </div>

//                       <div className="mb-3 md:mb-4">
//                         <label className="block text-sm font-medium mb-1 md:mb-2">
//                           WhatsApp Number (Ethiopian) *
//                         </label>
//                         <input
//                           type="tel"
//                           className={`w-full px-3 py-2 md:px-4 md:py-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
//                             errors.phone ? "border-red-500" : "border-gray-300"
//                           }`}
//                           value={formData.phone}
//                           onChange={(e) =>
//                             setFormData({ ...formData, phone: e.target.value })
//                           }
//                           placeholder="+251911223344 or 0911223344"
//                         />
//                         {errors.phone && (
//                           <p className="text-red-500 text-xs mt-1">
//                             {errors.phone}
//                           </p>
//                         )}
//                       </div>

//                       <div className="mb-3 md:mb-4">
//                         <label className="block text-sm font-medium mb-1 md:mb-2">
//                           Instagram Handle *
//                         </label>
//                         <div className="flex">
//                           <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
//                             @
//                           </span>
//                           <input
//                             type="text"
//                             className={`flex-1 min-w-0 block w-full px-3 py-2 md:py-3 rounded-none rounded-r-md border focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
//                               errors.instagram
//                                 ? "border-red-500"
//                                 : "border-gray-300"
//                             }`}
//                             value={formData.instagram}
//                             onChange={(e) =>
//                               setFormData({
//                                 ...formData,
//                                 instagram: e.target.value,
//                               })
//                             }
//                             placeholder="username (without @)"
//                           />
//                         </div>
//                         {errors.instagram && (
//                           <p className="text-red-500 text-xs mt-1">
//                             {errors.instagram}
//                           </p>
//                         )}
//                       </div>

//                       <div className="mb-3 md:mb-4">
//                         <label className="block text-sm font-medium mb-1 md:mb-2">
//                           Preferred City *
//                         </label>
//                         <select
//                           className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
//                           value={formData.cityPreference}
//                           onChange={(e) =>
//                             setFormData({
//                               ...formData,
//                               cityPreference: e.target.value,
//                             })
//                           }
//                         >
//                           <option value="dubai">Dubai</option>
//                           <option value="istanbul">Istanbul</option>
//                           <option value="moscow">Moscow</option>
//                           <option value="miami">Miami</option>
//                           <option value="beijing">Beijing</option>
//                         </select>
//                       </div>

//                       <div>
//                         <label className="block text-sm font-medium mb-1 md:mb-2">
//                           Experience & Skills *
//                         </label>
//                         <textarea
//                           rows={4}
//                           className={`w-full px-3 py-2 md:px-4 md:py-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
//                             errors.experience
//                               ? "border-red-500"
//                               : "border-gray-300"
//                           }`}
//                           value={formData.experience}
//                           onChange={(e) =>
//                             setFormData({
//                               ...formData,
//                               experience: e.target.value,
//                             })
//                           }
//                           placeholder="Describe your experience, training, special skills, and any performances"
//                         />
//                         {errors.experience && (
//                           <p className="text-red-500 text-xs mt-1">
//                             {errors.experience}
//                           </p>
//                         )}
//                       </div>
//                     </div>

//                     {/* Right Column - Photo Uploads */}
//                     <div>
//                       <h3 className="text-base md:text-lg font-semibold mb-3 md:mb-4 text-yellow-600 border-b pb-2">
//                         Portfolio Requirements
//                       </h3>

//                       <PhotoUploadBox
//                         type="headshot"
//                         label="Clear Headshot"
//                         description="Front-facing, neutral expression, good lighting"
//                       />

//                       <PhotoUploadBox
//                         type="fullFront"
//                         label="Full Body (Front)"
//                         description="Form-fitting clothing, neutral background"
//                       />

//                       <PhotoUploadBox
//                         type="fullBack"
//                         label="Full Body (Back)"
//                         description="Form-fitting clothing, neutral background"
//                       />

//                       <PhotoUploadBox
//                         type="fullSide"
//                         label="Full Body (Side)"
//                         description="Form-fitting clothing, neutral background"
//                       />

//                       <PhotoUploadBox
//                         type="actionShot"
//                         label="Action/Dance Shot"
//                         description="Showcasing movement or technique"
//                       />

//                       {errors.photos && (
//                         <div className="bg-red-50 border-l-4 border-red-500 p-3 md:p-4 mb-3 md:mb-4">
//                           <div className="flex">
//                             <div className="flex-shrink-0">
//                               <FaTimes className="h-4 w-4 md:h-5 md:w-5 text-red-500" />
//                             </div>
//                             <div className="ml-3">
//                               <p className="text-xs md:text-sm text-red-700">
//                                 {errors.photos}
//                               </p>
//                             </div>
//                           </div>
//                         </div>
//                       )}

//                       <div className="mt-4 md:mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-3 md:p-4">
//                         <p className="text-xs md:text-sm text-yellow-800">
//                           <span className="font-bold">Note:</span> High-quality
//                           photos increase your chances significantly. Wear
//                           form-fitting clothing that shows your physique
//                           clearly. No heavily edited or filtered images.
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="mt-6 md:mt-8">
//                     <button
//                       type="submit"
//                       disabled={isSubmitting}
//                       className={`w-full ${
//                         isSubmitting
//                           ? "bg-yellow-400 cursor-not-allowed"
//                           : "bg-yellow-500 hover:bg-yellow-600"
//                       } text-black font-bold py-3 px-4 md:py-4 md:px-6 rounded-lg transition flex items-center justify-center shadow-md hover:shadow-lg`}
//                     >
//                       {isSubmitting ? (
//                         <>
//                           <svg
//                             className="animate-spin -ml-1 mr-2 h-4 w-4 md:h-5 md:w-5 text-black"
//                             xmlns="http://www.w3.org/2000/svg"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                           >
//                             <circle
//                               className="opacity-25"
//                               cx="12"
//                               cy="12"
//                               r="10"
//                               stroke="currentColor"
//                               strokeWidth="4"
//                             ></circle>
//                             <path
//                               className="opacity-75"
//                               fill="currentColor"
//                               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                             ></path>
//                           </svg>
//                           Processing Your Application...
//                         </>
//                       ) : (
//                         "Submit Portfolio for Review"
//                       )}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </motion.div>
//           ) : step === "checklist" ? (
//             <div ref={checklistRef}>
//               <ComplianceChecklist
//                 onComplete={handleChecklistComplete}
//                 isComplete={checklistComplete}
//                 showSuccessAnimation={showSuccessAnimation}
//               />
//             </div>
//           ) : (
//             step === "approved" && (
//               <div ref={approvalRef}>
//                 <VisaApprovalModal
//                   name={formData.name}
//                   city={formData.cityPreference}
//                   onClose={() => {
//                     setStep("form");
//                     // Reset form for new submission
//                     setFormData({
//                       name: "",
//                       phone: "",
//                       instagram: "",
//                       experience: "",
//                       cityPreference: "dubai",
//                     });
//                     setPhotos({
//                       headshot: null,
//                       fullFront: null,
//                       fullBack: null,
//                       fullSide: null,
//                       actionShot: null,
//                     });
//                     setPhotoPreviews({
//                       headshot: null,
//                       fullFront: null,
//                       fullBack: null,
//                       fullSide: null,
//                       actionShot: null,
//                     });
//                     setChecklistComplete(false);

//                     // Scroll back to form
//                     setTimeout(() => {
//                       formSectionRef.current?.scrollIntoView({
//                         behavior: "smooth",
//                         block: "start",
//                       });
//                     }, 100);
//                   }}
//                 />
//               </div>
//             )
//           )}
//         </AnimatePresence>
//       </div>
//     </section>
//   );
// }

function ApplyForm() {
  const [step, setStep] = useState("form");
  const [showGatekeeper, setShowGatekeeper] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    instagram: "",
    experience: "",
    cityPreference: "dubai",
  });
  const [photos, setPhotos] = useState({
    headshot: null,
    fullFront: null,
    fullBack: null,
    fullSide: null,
    actionShot: null,
  });
  const [photoPreviews, setPhotoPreviews] = useState({
    headshot: null,
    fullFront: null,
    fullBack: null,
    fullSide: null,
    actionShot: null,
  });
  const [errors, setErrors] = useState({});
  const [checklistComplete, setChecklistComplete] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);

  const formSectionRef = useRef(null);
  const checklistRef = useRef(null);
  const approvalRef = useRef(null);

  const fileInputRefs = {
    headshot: useRef(null),
    fullFront: useRef(null),
    fullBack: useRef(null),
    fullSide: useRef(null),
    actionShot: useRef(null),
  };

  // Function to compress image
  const compressImage = async (file, type) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set maximum dimensions
          const MAX_WIDTH = 1024;
          const MAX_HEIGHT = 1024;

          let width = img.width;
          let height = img.height;

          // Calculate new dimensions while maintaining aspect ratio
          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }

          // Set canvas dimensions
          canvas.width = width;
          canvas.height = height;

          // Draw and compress image
          ctx.drawImage(img, 0, 0, width, height);

          // Determine quality based on file size
          let quality = 0.7; // default quality
          if (file.size > 2000000) {
            // if > 2MB
            quality = 0.6;
          } else if (file.size > 1000000) {
            // if > 1MB
            quality = 0.7;
          } else {
            quality = 0.8;
          }

          // Convert to blob with specified quality
          canvas.toBlob(
            (blob) => {
              // Create a new file with compressed blob
              const compressedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            },
            "image/jpeg",
            quality
          );
        };
      };
      reader.readAsDataURL(file);
    });
  };

  const validateEthiopianPhone = (phone) => {
    return /^(\+251|0)9[0-9]{8}$/.test(phone);
  };

  const validateInstagram = (handle) => {
    return /^[a-zA-Z0-9._]{1,30}$/.test(handle);
  };

  const handlePhotoChange = async (type, e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.match("image.*")) {
        setErrors((prev) => ({
          ...prev,
          photos: `Please upload an image file for ${type}`,
        }));
        return;
      }

      // Validate file size
      if (file.size > 5 * 1024 * 1024) {
        setErrors((prev) => ({
          ...prev,
          photos: `Image file too large (max 5MB) for ${type}`,
        }));
        return;
      }

      try {
        // Compress the image before setting state
        const compressedFile = await compressImage(file, type);

        setPhotos((prev) => ({ ...prev, [type]: compressedFile }));

        // Create preview from compressed file
        const reader = new FileReader();
        reader.onloadend = () => {
          setPhotoPreviews((prev) => ({ ...prev, [type]: reader.result }));
        };
        reader.readAsDataURL(compressedFile);

        // Clear any photo errors when a valid file is selected
        if (errors.photos) {
          setErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors.photos;
            return newErrors;
          });
        }
      } catch (error) {
        console.error("Error compressing image:", error);
        setErrors((prev) => ({
          ...prev,
          photos: `Error processing image for ${type}`,
        }));
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full name is required";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    if (!validateEthiopianPhone(formData.phone)) {
      newErrors.phone =
        "Valid Ethiopian phone number required (e.g. +251911223344 or 0911223344)";
    }

    if (!validateInstagram(formData.instagram)) {
      newErrors.instagram = "Valid Instagram handle required (no @ symbol)";
    }

    if (!formData.experience.trim()) {
      newErrors.experience = "Please describe your experience";
    } else if (formData.experience.trim().length < 20) {
      newErrors.experience =
        "Please provide more details (at least 20 characters)";
    }

    // Check if all required photos are uploaded
    const requiredPhotos = ["headshot", "fullFront", "fullBack", "fullSide"];
    const missingPhotos = requiredPhotos.filter((type) => !photos[type]);

    if (missingPhotos.length > 0) {
      newErrors.photos = `Missing required photos: ${missingPhotos
        .map((type) => type.replace(/([A-Z])/g, " $1").trim())
        .join(", ")}`;

      // Focus the first missing photo input
      const firstMissing = missingPhotos[0];
      if (fileInputRefs[firstMissing]?.current) {
        fileInputRefs[firstMissing].current.focus();
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);

      // Ross Jeffries' technique: Trigger gatekeeper flow
      await new Promise((resolve) => setTimeout(resolve, 500));
      setShowGatekeeper(true);

      setIsSubmitting(false);

      try {
        // First scroll to #apply section
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Then simulate API call/processing delay
        await new Promise((resolve) => setTimeout(resolve, 1500));

        setStep("checklist");

        const applySection = document.getElementById("apply");
        if (applySection) {
          applySection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }

        // Finally, scroll to checklist section
        setTimeout(() => {
          checklistRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      } catch (error) {
        console.error("Submission error:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleChecklistComplete = async () => {
    setChecklistComplete(true);
    try {
      // Show success animation
      setShowSuccessAnimation(true);

      // Send data to Telegram with all photos
      const success = await sendToTelegram(formData, photos);

      if (!success) {
        throw new Error("Telegram notification failed");
      }

      // Simulate processing delay
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setStep("approved");

      // Smooth scroll to approval section
      setTimeout(() => {
        approvalRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    } catch (error) {
      console.error("Error sending to Telegram:", error);
      // Handle error state if needed
    } finally {
      setShowSuccessAnimation(false);
    }
  };

  const PhotoUploadBox = ({ type, label, description }) => (
    <div className="mb-4 md:mb-6">
      <label className="block text-sm font-medium mb-1 md:mb-2">
        {label}{" "}
        {photos[type] ? (
          <span className="text-green-500 ml-2">
            <FaCheck className="inline" /> Uploaded
          </span>
        ) : (
          <span className="text-red-500 ml-2">*required</span>
        )}
      </label>
      <div className="flex items-start space-x-3 md:space-x-4">
        <div className="relative">
          <div className="w-20 h-20 md:w-24 md:h-24 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center overflow-hidden">
            {photoPreviews[type] ? (
              <img
                src={photoPreviews[type]}
                alt={label}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              <FaImage className="text-gray-400 text-xl md:text-2xl" />
            )}
          </div>
          <input
            type="file"
            onChange={(e) => handlePhotoChange(type, e)}
            accept="image/*"
            className="sr-only"
            name={`photo-${type}`}
            id={`photo-${type}`}
            ref={fileInputRefs[type]}
          />
          <label
            htmlFor={`photo-${type}`}
            className="absolute -bottom-2 -right-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-full p-1 md:p-2 cursor-pointer transition shadow-md"
            title={`Upload ${label}`}
          >
            <FaCamera className="text-xs" />
          </label>
        </div>
        <div className="flex-1">
          <p className="text-xs md:text-sm text-gray-600">{description}</p>
          {type === "headshot" && (
            <p className="text-xs text-gray-500 mt-1">
              High resolution, natural lighting, no filters or heavy makeup
            </p>
          )}
          {type === "actionShot" && (
            <p className="text-xs text-gray-500 mt-1">
              Optional but highly recommended (performance or dance)
            </p>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <section
      id="apply"
      className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-gray-100"
      ref={formSectionRef}
    >
      <div className="container mx-auto px-4 max-w-4xl">
        <AnimatePresence mode="wait">
          {showGatekeeper ? (
            <GatekeeperPhotoReview
              onComplete={() => {
                setShowGatekeeper(false);
                setStep("checklist");
              }}
            />
          ) : step === "form" ? (
            <motion.div
              key="form"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="bg-white rounded-xl shadow-2xl overflow-hidden"
            >
              <div className="p-6 md:p-10">
                <div className="text-center mb-6 md:mb-8">
                  <h2 className="text-xl md:text-3xl font-bold mb-2 md:mb-3">
                    Talent Application Portfolio
                  </h2>
                  <p className="text-gray-600 text-sm md:text-base">
                    Complete this form to be considered for our international
                    talent program
                  </p>
                  <TalentRotate />
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                    {/* Left Column - Personal Info */}
                    <div>
                      <h3 className="text-base md:text-lg font-semibold mb-3 md:mb-4 text-yellow-600 border-b pb-2">
                        Personal Information
                      </h3>

                      <div className="mb-3 md:mb-4">
                        <label className="block text-sm font-medium mb-1 md:mb-2">
                          Full Name *
                        </label>
                        <input
                          type="text"
                          className={`w-full px-3 py-2 md:px-4 md:py-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
                            errors.name ? "border-red-500" : "border-gray-300"
                          }`}
                          value={formData.name}
                          onChange={(e) =>
                            setFormData({ ...formData, name: e.target.value })
                          }
                          placeholder="Your full legal name"
                        />
                        {errors.name && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.name}
                          </p>
                        )}
                      </div>

                      <div className="mb-3 md:mb-4">
                        <label className="block text-sm font-medium mb-1 md:mb-2">
                          WhatsApp Number (Ethiopian) *
                        </label>
                        <input
                          type="tel"
                          className={`w-full px-3 py-2 md:px-4 md:py-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
                            errors.phone ? "border-red-500" : "border-gray-300"
                          }`}
                          value={formData.phone}
                          onChange={(e) =>
                            setFormData({ ...formData, phone: e.target.value })
                          }
                          placeholder="+251911223344 or 0911223344"
                        />
                        {errors.phone && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.phone}
                          </p>
                        )}
                      </div>

                      <div className="mb-3 md:mb-4">
                        <label className="block text-sm font-medium mb-1 md:mb-2">
                          Instagram Handle *
                        </label>
                        <div className="flex">
                          <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                            @
                          </span>
                          <input
                            type="text"
                            className={`flex-1 min-w-0 block w-full px-3 py-2 md:py-3 rounded-none rounded-r-md border focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
                              errors.instagram
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                            value={formData.instagram}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                instagram: e.target.value,
                              })
                            }
                            placeholder="username (without @)"
                          />
                        </div>
                        {errors.instagram && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.instagram}
                          </p>
                        )}
                      </div>

                      <div className="mb-3 md:mb-4">
                        <label className="block text-sm font-medium mb-1 md:mb-2">
                          Preferred City *
                        </label>
                        <select
                          className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                          value={formData.cityPreference}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              cityPreference: e.target.value,
                            })
                          }
                        >
                          <option value="dubai">Dubai</option>
                          <option value="istanbul">Istanbul</option>
                          <option value="moscow">Moscow</option>
                          <option value="miami">Miami</option>
                          <option value="beijing">Beijing</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1 md:mb-2">
                          Experience & Skills *
                        </label>
                        <textarea
                          rows={4}
                          className={`w-full px-3 py-2 md:px-4 md:py-3 border rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 ${
                            errors.experience
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          value={formData.experience}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              experience: e.target.value,
                            })
                          }
                          placeholder="Describe your experience, training, special skills, and any performances"
                        />
                        {errors.experience && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.experience}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Right Column - Photo Uploads */}
                    <div>
                      <h3 className="text-base md:text-lg font-semibold mb-3 md:mb-4 text-yellow-600 border-b pb-2">
                        Portfolio Requirements
                      </h3>

                      <PhotoUploadBox
                        type="headshot"
                        label="Clear Headshot"
                        description="Front-facing, neutral expression, good lighting"
                      />

                      <PhotoUploadBox
                        type="fullFront"
                        label="Full Body (Front)"
                        description="Form-fitting clothing, neutral background"
                      />

                      <PhotoUploadBox
                        type="fullBack"
                        label="Full Body (Back)"
                        description="Form-fitting clothing, neutral background"
                      />

                      <PhotoUploadBox
                        type="fullSide"
                        label="Full Body (Side)"
                        description="Form-fitting clothing, neutral background"
                      />

                      <PhotoUploadBox
                        type="actionShot"
                        label="Action/Dance Shot"
                        description="Showcasing movement or technique"
                      />

                      {errors.photos && (
                        <div className="bg-red-50 border-l-4 border-red-500 p-3 md:p-4 mb-3 md:mb-4">
                          <div className="flex">
                            <div className="flex-shrink-0">
                              <FaTimes className="h-4 w-4 md:h-5 md:w-5 text-red-500" />
                            </div>
                            <div className="ml-3">
                              <p className="text-xs md:text-sm text-red-700">
                                {errors.photos}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="mt-4 md:mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-3 md:p-4">
                        <p className="text-xs md:text-sm text-yellow-800">
                          <span className="font-bold">Note:</span> High-quality
                          photos increase your chances significantly. Wear
                          form-fitting clothing that shows your physique
                          clearly. No heavily edited or filtered images.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 md:mt-8">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`w-full ${
                        isSubmitting
                          ? "bg-yellow-400 cursor-not-allowed"
                          : "bg-yellow-500 hover:bg-yellow-600"
                      } text-black font-bold py-3 px-4 md:py-4 md:px-6 rounded-lg transition flex items-center justify-center shadow-md hover:shadow-lg`}
                    >
                      {isSubmitting ? (
                        <>
                          <svg
                            className="animate-spin -ml-1 mr-2 h-4 w-4 md:h-5 md:w-5 text-black"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Processing Your Application...
                        </>
                      ) : (
                        "Submit Portfolio for Review"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </motion.div>
          ) : step === "checklist" ? (
            <div ref={checklistRef}>
              <ComplianceChecklist
                onComplete={handleChecklistComplete}
                isComplete={checklistComplete}
                showSuccessAnimation={showSuccessAnimation}
              />
            </div>
          ) : (
            step === "approved" && (
              <div ref={approvalRef}>
                <VisaApprovalModal
                  name={formData.name}
                  city={formData.cityPreference}
                  onClose={() => {
                    setStep("form");
                    // Reset form for new submission
                    setFormData({
                      name: "",
                      phone: "",
                      instagram: "",
                      experience: "",
                      cityPreference: "dubai",
                    });
                    setPhotos({
                      headshot: null,
                      fullFront: null,
                      fullBack: null,
                      fullSide: null,
                      actionShot: null,
                    });
                    setPhotoPreviews({
                      headshot: null,
                      fullFront: null,
                      fullBack: null,
                      fullSide: null,
                      actionShot: null,
                    });
                    setChecklistComplete(false);

                    // Scroll back to form
                    setTimeout(() => {
                      formSectionRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }, 100);
                  }}
                />
              </div>
            )
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}

function ComplianceChecklist({ onComplete, isComplete, showSuccessAnimation }) {
  const checklistItems = [
    {
      id: 1,
      text: "Age between 21-30 years",
      icon: <FaUserShield className="text-yellow-500 mr-2" />,
      description: "Must be born between 1995-2003 for visa eligibility",
    },
    {
      id: 2,
      text: "Passport valid for 6+ months",
      icon: <FaPassport className="text-yellow-500 mr-2" />,
      description: "With at least 2 blank pages",
    },
    {
      id: 3,
      text: "No criminal record",
      icon: <FaUserShield className="text-yellow-500 mr-2" />,
      description: "Must be able to obtain police clearance",
    },
    {
      id: 4,
      text: "Minimum 2 years experience",
      icon: <FaUserShield className="text-yellow-500 mr-2" />,
      description: "Professional performance or modeling experience",
    },
    {
      id: 5,
      text: "Physically fit for performances",
      icon: <FaUserShield className="text-yellow-500 mr-2" />,
      description: "Able to perform 4-6 nights weekly",
    },
  ];

  const [checkedItems, setCheckedItems] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress((checkedItems.length / checklistItems.length) * 100);
    if (checkedItems.length === checklistItems.length && !isComplete) {
      onComplete();
    }
  }, [checkedItems, isComplete, onComplete, checklistItems.length]);

  return (
    <motion.div
      id="apply-fake"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="bg-white rounded-xl shadow-2xl overflow-hidden p-6 md:p-8 text-center max-w-2xl mx-auto"
    >
      <h3 className="text-lg md:text-2xl font-bold mb-4 md:mb-6 text-center">
        Visa Pre-Screening Checklist
      </h3>

      <div className="mb-6 md:mb-8">
        <div className="flex items-center justify-between mb-1 md:mb-2">
          <span className="text-xs md:text-sm font-medium">
            {isComplete ? "Complete!" : "Screening Progress"}
          </span>
          <span className="text-xs md:text-sm font-medium">
            {Math.round(progress)}%
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 md:h-2.5">
          <motion.div
            className="bg-yellow-500 h-2 md:h-2.5 rounded-full"
            initial={{ width: "0%" }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.5 }}
          />
        </div>
      </div>

      <ul id="checklist" className="space-y-3 md:space-y-4 mb-6 md:mb-8">
        {checklistItems.map((item) => (
          <motion.li
            key={item.id}
            className="flex items-start bg-gray-50 p-3 md:p-4 rounded-lg border border-gray-200"
            whileHover={{ x: 5 }}
          >
            <input
              type="checkbox"
              id={`item-${item.id}`}
              checked={checkedItems.includes(item.id)}
              onChange={() => {
                if (checkedItems.includes(item.id)) {
                  setCheckedItems(checkedItems.filter((i) => i !== item.id));
                } else {
                  setCheckedItems([...checkedItems, item.id]);
                }
              }}
              disabled={isComplete}
              className="mt-1 mr-2 md:mr-3 h-4 w-4 md:h-5 md:w-5 rounded border-gray-300 text-yellow-600 focus:ring-yellow-500"
            />
            <label htmlFor={`item-${item.id}`} className="flex-1">
              <div className="flex items-center">
                {item.icon}
                <span
                  className={
                    checkedItems.includes(item.id)
                      ? "line-through opacity-70"
                      : "font-medium"
                  }
                >
                  {item.text}
                </span>
              </div>
              <p className="text-xs text-gray-500 mt-1 ml-5 md:ml-6">
                {item.description}
              </p>
            </label>
          </motion.li>
        ))}
      </ul>

      {showSuccessAnimation && (
        <motion.div
          className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white p-6 md:p-8 rounded-xl max-w-sm text-center"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
          >
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ repeat: 3, duration: 0.5 }}
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <FaCheck className="text-green-500 text-xl md:text-2xl" />
              </div>
            </motion.div>
            <h4 className="text-lg md:text-xl font-bold mb-1 md:mb-2">
              Submission Successful!
            </h4>
            <p className="text-gray-600 text-sm md:text-base">
              Your application is being processed. Please wait...
            </p>
          </motion.div>
        </motion.div>
      )}

      {isComplete && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center"
        >
          <div className="bg-green-50 border border-green-200 rounded-lg p-3 md:p-4 mb-4 md:mb-6">
            <p className="text-green-700 font-medium text-sm md:text-base">
              ✓ Congratulations! You've passed initial screening
            </p>
          </div>
          {/* Ross Jeffries Principle: Future Pacing with Sensory Language */}
          <p className="text-xs md:text-sm text-gray-600 mb-4 md:mb-6 italic">
            "As you complete this process, notice how your excitement grows when
            imagining your new life abroad. That feeling will become your
            reality very soon..."
          </p>
        </motion.div>
      )}

      {!isComplete && (
        <p className="text-xs md:text-sm text-gray-500 text-center">
          Completing this checklist increases your approval chances by 70%
        </p>
      )}
    </motion.div>
  );
}

function VisaApprovalModal({ name, city, onClose }) {
  const cityDetails = {
    dubai: {
      earnings: "$3,000 - $5,000",
      visa: "UAE Creative Visa",
      contact: "+971501234567",
      image: dummyImages.dubaiCity,
      benefits: [
        "Tax-free income",
        "Luxury shared accommodation",
        "Health insurance",
        "30-day visa processing",
      ],
    },
    istanbul: {
      earnings: "$2,500 - $4,000",
      visa: "Turkish Artist Visa",
      contact: "+905555555555",
      image: dummyImages.istanbulCity,
      benefits: [
        "EU travel opportunities",
        "Private studio apartment",
        "Performance bonuses",
        "45-day visa processing",
      ],
    },
    moscow: {
      earnings: "€2,500 - €4,000",
      visa: "Russian Work Permit",
      contact: "+79161234567",
      image: dummyImages.moscowCity,
      benefits: [
        "High earning potential",
        "Central location apartment",
        "Visa sponsorship",
        "60-day visa processing",
      ],
    },
    miami: {
      earnings: "$3,500 - $6,000",
      visa: "US P1 Visa",
      contact: "+13055551234",
      image: dummyImages.miamiCity,
      benefits: [
        "Highest earning potential",
        "Shared luxury condo",
        "Performance incentives",
        "90-day visa processing",
      ],
    },
    beijing: {
      earnings: "$2,800 - $4,500",
      visa: "Chinese Z Visa",
      contact: "+8613812345678",
      image: dummyImages.beijingCity,
      benefits: [
        "All expenses paid",
        "Private accommodation",
        "Language assistance",
        "75-day visa processing",
      ],
    },
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      className="bg-white rounded-xl shadow-2xl overflow-hidden p-6 md:p-8 text-center max-w-2xl mx-auto"
    >
      <div className="mb-6 md:mb-8">
        <motion.div
          className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-green-100 rounded-full mb-3 md:mb-4 mx-auto"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <svg
            className="w-8 h-8 md:w-10 md:h-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </motion.div>

        <motion.h3
          className="text-xl md:text-3xl font-bold mb-1 md:mb-2"
          variants={itemVariants}
        >
          PRE-APPROVED FOR {city.toUpperCase()}!
        </motion.h3>
        <motion.p
          className="mb-4 md:mb-6 text-base md:text-lg"
          variants={itemVariants}
        >
          Congratulations {name.split(" ")[0]}! You've passed our screening for{" "}
          {city.toUpperCase()}.
        </motion.p>
      </div>

      <motion.div
        className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 md:p-6 mb-6 md:mb-8 text-left"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="flex flex-col md:flex-row">
          <div className="flex-1">
            <motion.h4
              className="font-bold mb-3 md:mb-4 text-center text-lg md:text-xl text-yellow-700"
              variants={itemVariants}
            >
              Your Potential Placement Details
            </motion.h4>
            <motion.ul
              className="space-y-2 md:space-y-3"
              variants={containerVariants}
            >
              <motion.li className="flex items-start" variants={itemVariants}>
                <span className="font-bold mr-2 min-w-[100px] md:min-w-[120px]">
                  City:
                </span>
                <span className="capitalize font-medium">{city}</span>
              </motion.li>
              <motion.li className="flex items-start" variants={itemVariants}>
                <span className="font-bold mr-2 min-w-[100px] md:min-w-[120px]">
                  Monthly Earnings:
                </span>
                <span className="font-medium">
                  {cityDetails[city].earnings}
                </span>
              </motion.li>
              <motion.li className="flex items-start" variants={itemVariants}>
                <span className="font-bold mr-2 min-w-[100px] md:min-w-[120px]">
                  Visa Type:
                </span>
                <span className="font-medium">{cityDetails[city].visa}</span>
              </motion.li>
              <motion.li className="flex items-start" variants={itemVariants}>
                <span className="font-bold mr-2 min-w-[100px] md:min-w-[120px]">
                  Benefits:
                </span>
                <ul className="list-disc list-inside space-y-1">
                  {cityDetails[city].benefits.map((benefit, i) => (
                    <motion.li
                      key={i}
                      variants={itemVariants}
                      className="text-sm md:text-base"
                    >
                      {benefit}
                    </motion.li>
                  ))}
                </ul>
              </motion.li>
            </motion.ul>
          </div>
          {/* <div className="mt-3 md:mt-0 md:ml-4 lg:ml-6 w-full md:w-40 lg:w-48 h-40 lg:h-48 rounded-lg overflow-hidden border border-gray-200">
            <LazyLoadImage
              src={cityDetails[city].image}
              alt={city}
              className="w-full h-full object-cover"
              effect="blur" // Optional blur effect
              beforeLoad={() => true} // Force immediate load
            />
          </div> */}
          <div className="mt-3 md:mt-0 md:ml-4 lg:ml-6 w-full md:w-40 lg:w-48 h-40 lg:h-48 rounded-lg overflow-hidden border border-gray-200">
            <LazyLoadImage
              src={cityDetails[city].image}
              alt={city}
              className="w-full h-full object-cover" // Key styles here
              effect="blur"
              width="100%" // Ensure responsive width
              height="100%" // Ensure responsive height
              style={{ display: "block" }} // Removes any default inline spacing
            />
          </div>
        </div>
      </motion.div>

      <motion.div className="mb-6 md:mb-8" variants={containerVariants}>
        <motion.h4
          className="font-bold mb-3 md:mb-4 text-lg text-center"
          variants={itemVariants}
        >
          Next Steps to Secure Your Placement:
        </motion.h4>
        <motion.ol
          className="list-decimal list-inside text-left space-y-2 md:space-y-3 text-xs md:text-sm max-w-md mx-auto"
          variants={containerVariants}
        >
          <motion.li variants={itemVariants}>
            Join our exclusive Telegram group for interview scheduling
          </motion.li>
          <motion.li variants={itemVariants}>
            Prepare a 2-minute performance video showcasing your skills
          </motion.li>
          <motion.li variants={itemVariants}>
            WhatsApp our placement manager to start visa process
          </motion.li>
        </motion.ol>
      </motion.div>

      {/* Ross Jeffries Principle: Anchoring Positive State */}
      <motion.div
        className="bg-black/5 p-3 md:p-4 rounded-lg mb-6 md:mb-8 italic text-xs md:text-sm"
        variants={itemVariants}
      >
        <p>
          "Can you feel the excitement of performing in {city.toUpperCase()}?
          That feeling will only grow stronger as we proceed with your visa
          application..."
        </p>
      </motion.div>

      <motion.div
        className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4 mb-6 md:mb-8"
        variants={containerVariants}
      >
        <motion.a
          href="https://t.me/selamscouts"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-lg shadow-md hover:shadow-lg transition"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          variants={itemVariants}
        >
          <FaTelegram className="mr-2 text-lg md:text-xl" /> Join Telegram Group
        </motion.a>
        <motion.a
          href={`https://wa.me/${cityDetails[city].contact.replace(
            /\s+/g,
            ""
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="pointer-events-none opacity-50 cursor-not-allowed inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-lg shadow-md hover:shadow-lg transition"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.98 }}
          variants={itemVariants}
        >
          <FaWhatsapp className="mr-2 text-lg md:text-xl " /> WhatsApp for Visa
        </motion.a>
      </motion.div>

      <motion.button
        onClick={onClose}
        className="text-xs md:text-sm text-gray-500 hover:text-gray-700 font-medium"
        variants={itemVariants}
      >
        Close This Window
      </motion.button>
    </motion.div>
  );
}

// Enhanced Partners Component with Psychological Triggers
function Partners() {
  const partners = [
    {
      name: "Poko Ajans",
      location: "Istanbul",
      image: dummyImages.partnerOne,
      type: "Talent Agency",
    },
    {
      name: "White Dubai",
      location: "Dubai",
      image: dummyImages.partnerTwo,
      type: "Premium Nightclub",
    },
    {
      name: "Icon Models",
      location: "Moscow",
      image: dummyImages.partnerThree,
      type: "Modeling Agency",
    },
    {
      name: "Miami Nights",
      location: "Miami",
      image: dummyImages.partnerFour,
      type: "Entertainment Group",
    },
    {
      name: "Dragon Talent",
      location: "Beijing",
      image: dummyImages.partnerFive,
      type: "Production Company",
    },
    {
      name: "UAE Creative Visa",
      location: "Dubai",
      image: dummyImages.partnerSix,
      type: "Visa Specialists",
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-gray-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 bg-[url('https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80')] bg-cover bg-center" />
      <div className="container mx-auto px-4 relative">
        <div className="text-center mb-8 md:mb-12">
          <h3 className="text-lg md:text-2xl text-center mb-3 md:mb-4 text-yellow-400 font-bold">
            Our Exclusive Network Partners
          </h3>
          <p className="text-gray-300 text-sm md:text-base max-w-2xl mx-auto">
            We work with top-tier venues and agencies worldwide to place our
            talents in premium positions
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
          {partners.map((partner, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05, y: -5 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex flex-col items-center justify-center p-3 md:p-5 bg-white/10 rounded-xl border border-yellow-400/20 text-white min-w-[120px] md:min-w-[160px] backdrop-blur-sm hover:bg-white/15 transition"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden mb-2 md:mb-3 border-2 border-yellow-400">
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="text-center">
                <p className="font-bold text-sm md:text-base">{partner.name}</p>
                <p className="text-yellow-300 text-xs md:text-sm mt-1">
                  {partner.location}
                </p>
                <p className="text-xs text-gray-300 mt-1 md:mt-2">
                  {partner.type}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center text-gray-400 max-w-3xl mx-auto">
          <p className="text-sm md:text-base">
            We maintain{" "}
            <span className="text-yellow-400 font-medium">
              exclusive relationships
            </span>{" "}
            with top venues worldwide. Selected talents gain access to our{" "}
            <span className="text-yellow-400 font-medium">private network</span>{" "}
            of clubs, agencies, and visa specialists - connections that would
            normally take years to establish.
          </p>
        </div>
      </div>
    </section>
  );
}

// Enhanced FAQ Component
const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  // Psychological trigger: Organize FAQs by category with different emotional appeals
  const faqCategories = [
    {
      name: "Application Process",
      icon: <FaRegLightbulb className="text-yellow-500 mr-2" />,
      questions: [
        {
          question: "How long does the application process take?",
          answer:
            "Our elite review team typically evaluates applications within 24-48 hours. The fastest 10% of applicants receive responses within 12 hours.",
          psychologicalTrigger: "Urgency + Social proof (fastest 10%)",
        },
        {
          question: "What are my chances of being accepted?",
          answer:
            "While we maintain high standards (accepting only 15% of applicants), your chances increase significantly with a complete portfolio and professional presentation. Our team looks for potential as much as experience.",
          psychologicalTrigger: "Scarcity (15%) + Hope",
        },
        {
          question: "Is there an application fee?",
          answer:
            "No, we never charge application fees. Our revenue comes from partner venues who pay us to connect them with exceptional talent like you.",
          psychologicalTrigger: "Reciprocity (free service)",
        },
      ],
    },
    {
      name: "Visa & Relocation",
      icon: <FaPassport className="text-blue-500 mr-2" />,
      questions: [
        {
          question: "Do you really handle all visa paperwork?",
          answer:
            "Yes! Our legal team specializes in entertainment visas and has a 94% approval rate across all destinations. We handle everything from documentation to embassy appointments.",
          psychologicalTrigger: "Authority (94% success rate)",
        },
        {
          question: "How long until I can start working abroad?",
          answer:
            "Most talents begin working within 3-6 weeks of acceptance. Our fastest placement was 11 days from application to first performance in Dubai.",
          psychologicalTrigger: "Social proof (fastest case)",
        },
        {
          question: "What if my visa gets denied?",
          answer:
            "In the rare case of denial (6% of applications), we immediately appeal or find alternative placement at no extra cost. Our success rate on appeals is 82%.",
          psychologicalTrigger: "Risk reversal + Statistics",
        },
      ],
    },
    {
      name: "Earnings & Benefits",
      icon: <FaMoneyBillWave className="text-green-500 mr-2" />,
      questions: [
        {
          question: "How much can I realistically earn?",
          answer:
            "Our talents average $3,500-$6,000 monthly, with top performers reaching $10,000+. Your earnings depend on venue, experience, and performance quality.",
          psychologicalTrigger: "Anchoring (high numbers first)",
        },
        {
          question: "What's included in the accommodation?",
          answer:
            "You'll enjoy fully furnished apartments in premium locations, with utilities, WiFi, and cleaning services included. Many are walking distance to your venue.",
          psychologicalTrigger: "Luxury visualization",
        },
        {
          question: "Are there performance bonuses?",
          answer:
            "Most venues offer 15-25% bonuses for exceptional performance. Our top talent earned $8,200 in bonuses last month alone.",
          psychologicalTrigger: "Social proof + Aspiration",
        },
      ],
    },
  ];

  const filteredCategories = faqCategories
    .map((category) => ({
      ...category,
      questions: category.questions.filter(
        (q) =>
          q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
          q.answer.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((category) => category.questions.length > 0);

  // Psychological trigger: Make the search feel personalized
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    if (e.target.value) {
      setActiveIndex(0); // Auto-open first result when searching
    }
  };

  // Properly implemented toggle function
  const toggleQuestion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4">
            Your <span className="text-yellow-500">Questions</span> Answered
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            We've helped over 200 talents navigate their international careers
          </p>

          {/* Psychological trigger: Interactive search makes users feel in control */}
          <div className="mt-6 md:mt-8 max-w-md mx-auto relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaSearch className="text-gray-400" />
            </div>
            <input
              type="text"
              className="block w-full pl-10 pr-3 py-2 md:py-3 border border-gray-300 rounded-lg bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
              placeholder="Search questions..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm("")}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <FaTimes className="text-gray-400 hover:text-gray-600" />
              </button>
            )}
          </div>
        </div>

        {filteredCategories.length === 0 ? (
          <div className="text-center py-8 md:py-12">
            <FaRegQuestionCircle className="mx-auto text-3xl md:text-4xl text-gray-400 mb-3 md:mb-4" />
            <h3 className="text-lg md:text-xl font-medium text-gray-600">
              No questions match your search
            </h3>
            <p className="text-gray-500 mt-1 md:mt-2 text-sm md:text-base">
              Try different keywords or contact us directly
            </p>
          </div>
        ) : (
          <div className="space-y-4 md:space-y-6">
            {filteredCategories.map((category, catIndex) => (
              <div
                key={catIndex}
                className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100"
              >
                <div className="bg-gray-50 px-4 py-3 md:px-6 md:py-4 border-b border-gray-200">
                  <h3 className="font-bold text-base md:text-lg flex items-center">
                    {category.icon}
                    {category.name}
                  </h3>
                </div>
                <div className="divide-y divide-gray-100">
                  {category.questions.map((item, index) => {
                    const questionIndex = catIndex * 100 + index; // Create unique index
                    const isActive = activeIndex === questionIndex;

                    return (
                      <div key={index} className="px-4 py-3 md:px-6 md:py-4">
                        <button
                          onClick={() => toggleQuestion(questionIndex)}
                          className="w-full flex justify-between items-center text-left focus:outline-none"
                        >
                          <span className="font-medium text-gray-900 pr-3 md:pr-4 text-sm md:text-base">
                            {item.question}
                          </span>
                          {isActive ? (
                            <FaChevronUp className="text-gray-500 flex-shrink-0" />
                          ) : (
                            <FaChevronDown className="text-gray-500 flex-shrink-0" />
                          )}
                        </button>

                        <AnimatePresence>
                          {isActive && (
                            <motion.div
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.2 }}
                              className="overflow-hidden"
                            >
                              <div className="pt-2 pb-1 md:pt-4 md:pb-2 text-gray-600 text-sm md:text-base">
                                {item.answer}
                                {/* Psychological trigger: Add CTA at the end of relevant answers */}
                                {(index === 0 ||
                                  index === category.questions.length - 1) && (
                                  <div className="mt-3 md:mt-4">
                                    <a
                                      href="#apply"
                                      className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-medium py-1 px-3 md:py-2 md:px-4 rounded-lg text-xs md:text-sm transition shadow-sm hover:shadow-md"
                                    >
                                      {index === 0
                                        ? "Start Your Application"
                                        : "Learn More About Benefits"}
                                    </a>
                                  </div>
                                )}
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Psychological trigger: "False bottom" with additional CTA */}
        <div className="mt-12 md:mt-16 text-center">
          <div className="bg-gradient-to-r from-yellow-50 to-gray-50 border border-yellow-200 rounded-xl p-4 md:p-6 max-w-2xl mx-auto">
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3">
              Still have questions?
            </h3>
            <p className="text-gray-600 mb-4 md:mb-6 text-sm md:text-base">
              Our talent scouts are available 24/7 to guide you through the
              process
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
              <a
                href="https://t.me/+uWvNfCLa9YViMTc8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-lg shadow-sm hover:shadow-md transition text-sm md:text-base"
              >
                <FaTelegram className="mr-2" /> Ask on Telegram
              </a>
              <a
                href="https://wa.me/+251911055612"
                target="_blank"
                rel="noopener noreferrer"
                className="pointer-events-none opacity-50 cursor-not-allowed inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-lg shadow-sm hover:shadow-md transition text-sm md:text-base"
              >
                <FaWhatsapp className="mr-2 " /> Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Enhanced Footer Component
function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white pt-12 pb-6 md:pt-16 md:pb-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 md:mb-12">
          <div className="mb-6 md:mb-0">
            <h3 className="text-xl md:text-2xl font-bold mb-2 md:mb-3">
              LucyTalentScouts
            </h3>
            <p className="text-gray-400 text-sm md:text-base max-w-md">
              Connecting exceptional Ethiopian talent with premium international
              opportunities since 2018.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 md:gap-8">
            <div>
              <h4 className="font-bold mb-2 md:mb-3 text-yellow-400 text-sm md:text-base">
                Quick Links
              </h4>
              <ul className="space-y-1 md:space-y-2">
                <li>
                  <Link
                    to="/terms"
                    className="text-gray-400 hover:text-yellow-400 transition text-xs md:text-sm"
                  >
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-gray-400 hover:text-yellow-400 transition text-xs md:text-sm"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <a
                    href="#apply"
                    className="text-gray-400 hover:text-yellow-400 transition text-xs md:text-sm"
                  >
                    Apply Now
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-2 md:mb-3 text-yellow-400 text-sm md:text-base">
                Contact
              </h4>
              <ul className="space-y-1 md:space-y-2">
                <li>
                  <a
                    href="https://t.me/selamscouts"
                    className="flex items-center text-gray-400 hover:text-blue-400 transition text-xs md:text-sm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTelegram className="mr-2" /> Telegram
                  </a>
                </li>
                <li>
                  <a
                    href="https://wa.me/+251911223344"
                    className="flex items-center text-gray-400 hover:text-green-400 transition text-xs md:text-sm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp className="mr-2" /> WhatsApp
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-6 md:pt-8 border-t border-gray-800 text-center text-gray-500 text-xs md:text-sm">
          <p>
            © {currentYear} LucyTalentScouts. | Official International Agency.
          </p>
          <p className="mt-1 md:mt-2">
            All applications are subject to approval. No fees required for
            screening process.
          </p>
        </div>
      </div>
    </footer>
  );
}
